import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  useCallback
} from 'react';
import {
  AppBar,
  Card,
  CircularProgress,
  Grid,
  StepButton,
  Switch,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Avatar,
  Popover,
  Skeleton,
  Divider
} from '@mui/material';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
// import {
//   BookTLShipment,
//   DispatchShipment,
//   GetQuote,
//   StartTLQuote
// } from '../../apis/AgencyWithoutAuthHeaders';
import SearchIcon from '@mui/icons-material/Search';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import { InputAdornment } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import { IconButton } from '@mui/material';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation'; // Bulk Tanker
import LocalShippingIcon from '@mui/icons-material/LocalShipping'; // Dry Van
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle'; // Sprinter
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat'; // For Reefer
import Inventory2Icon from '@mui/icons-material/Inventory2';
import TrainIcon from '@mui/icons-material/Train';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import './PickupShipment.css';
import { useSelector } from 'react-redux';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Paper from '@mui/material/Paper';
import { Autocomplete, Button, TextField } from '@mui/material';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useHistory } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { ErrorToast } from '../../components/Toasts';
import NoLogo from '../../assets/carrier logos/No Logo.png';
import TLRatingScreen from '../GetRate/TLRatingScreen';

import {
  BookTLShipment,
  CreateShipment,
  DispatchShipment,
  GetActiveCarriers,
  GetQuote,
  GetShipmentDetails,
  StartTLQuote,
  UpdateShipmentDetail
} from '../../apis/Agency';
import dayjs from 'dayjs';
import { base_logo_url } from '../../apis/constants';
import { useIsMobile } from '../../components/IsMobileHook/IsMobileHook';
import { formatNumberWithCommas } from '../../apis/Utils';
import { MenuItem } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import TLShipmentPreview from '../TShipmentPreview';
export default function BookShipmentReviewTL(props) {
  let UpdatedStoredServices = useRef(null);
  const isMobile = useIsMobile();

  const enterSONumber = useRef(null);
  const enterPONumber = useRef(null);

  const isQuickQuoteRate = props?.location?.state?.rateType !== 'Quick Quote';

  const history = useHistory();
  const PreviousProps =
    props?.location?.state?.pickupRowData !== undefined &&
    JSON.parse(props?.location?.state?.pickupRowData);
  const [customerPoNmb, setCustomerPoNmb] = useState(
    PreviousProps?.clientPONumber ?? ''
  );
  const [shipmentFailedMsg, setShipmentFailedMsg] = useState('');
  const [saleOrderNumber, setSaleOrderNumber] = useState(
    PreviousProps?.soNumber ?? ''
  );
  console.log(PreviousProps, 'PreviousProps');
  const previousQuoteId = JSON.parse(props?.location?.state?.pickupRowData);
  const quoteFlowType = props?.location?.state?.rateType;
  const [shipStatus, setShipStatus] = useState(PreviousProps?.shipmentStatus);
  const AgencyID = useSelector(state => state.userDetails.agencyLoginID);
  const CarrierRateData = useSelector(state => state.getCarrierRates);
  const [pickupNumber, setPickupNumber] = useState(
    PreviousProps?.pickupNumber ? PreviousProps?.pickupNumber : ''
  );
  const [proNumber, setProNumber] = useState('');
  const [refOrQuoteNmb, setRefOrQuoteNmb] = useState(
    PreviousProps?.quoteNumber ? PreviousProps?.quoteNumber : ''
  );
  const [open, setOpen] = useState(false);
  const [quoteType, setQuoteType] = useState(
    quoteFlowType ? quoteFlowType : ''
  );
  const [openOtherCarrier, setOpenOtherCarrier] = useState(false);
  const [otherCarrierName, setOtherCarrierName] = useState('');
  const [truckNumber, setTruckNumber] = useState('');
  const [driverName, setDriverName] = useState('');
  const [carrierName, setCarrierName] = useState(null);
  const [driverNumber, setDriverNumber] = useState('');
  const [phoneNumberValidError, setPhoneNumberValidError] = useState(false);
  const [userPermissionsArr, setUserPermissionsArr] = useState(null);
  const UserIsAdmin = useSelector(state => state.userDetails.isAdmin);

  const [, setOriginDate] = useState(new Date());
  const [, setDestinationDate] = useState(new Date());
  const [originOpenTimeValue, setOriginOpenTimeValue] = useState(
    dayjs('2024-02-17T08:00').format('HH:mm') // Extract time part
  );
  const [originCloseTimeValue, setOriginCloseTimeValue] = useState(
    dayjs('2024-02-17T16:00').format('HH:mm') // Extract time part
  );
  const [destinationOpenTimeValue, setDestinationOpenTimeValue] = useState(
    dayjs('2024-02-17T09:00').format('HH:mm') // Extract time part
  );

  const [destinationCloseTimeValue, setDestinationCloseTimeValue] = useState(
    dayjs('2024-02-17T05:00').format('HH:mm') // Extract time part
  );

  const [shipmentBooked, setShipmentBooked] = useState(false);
  const [pickUpLoader, setPickUpLoader] = useState(false);
  const [createdShipmentId, setCreatedShipmentId] = useState(
    PreviousProps?.id ? PreviousProps?.id : ''
  );
  const [shipmentDispatchMsg, setShipmentDispatchMsg] = useState('');
  const [shipmentDispatchFailed, setShipmentDispatchFailed] = useState(false);
  const [pickupSuccessRemarks] = useState('');
  const [shipmentFailed, setShipmentFailed] = useState(false);
  const ClassArray = [
    '50',
    '55',
    '60',
    '65',
    '70',
    '77.5',
    '85',
    '92.5',
    '100',
    '110',
    '125',
    '150',
    '175',
    '200',
    '250',
    '300',
    '400',
    '500'
  ];
  const [value, setValue] = useState(0);
  const [tabConfirmValue] = useState(0);
  const [tabChanged] = useState(false);
  const [, setFinalCommodityInfoApi] = useState([]);
  const [, setTotalWeightSum] = useState('');

  const [newAddedClassRow, setNewAddedClassRow] = useState([
    PreviousProps?.carrierApiNames === 'carrierApiNames'
      ? {
          WeightLBS: CarrierRateData?.commodityInfo?.[0]?.weight?.value,
          Class: CarrierRateData?.commodityInfo?.[0]?.freightClass,
          NMFCnumber: CarrierRateData?.commodityInfo?.[0]?.nmfc
        }
      : {
          WeightLBS: PreviousProps?.pickupRowData?.details?.[0]?.netWeight,
          Class: CarrierRateData?.commodityInfo?.[0]?.freightClass,
          NMFCnumber: CarrierRateData?.commodityInfo?.[0]?.nmfc
        }
  ]);

  const [totalLBSWeightDimensions] = useState('');
  const [, setTotalLBSWeightClass] = useState('');
  const handlePushAddedCommodityInfo = TotalWeightSum => {
    let CommodityInfoApi = [
      {
        freightClass: newAddedClassRow[0].Class,
        packaging: 'Pallet',
        pieces: 1,
        weight: {
          units: 'lbs',
          value: TotalWeightSum ? TotalWeightSum : 0
        },
        nmfc: newAddedClassRow[0].NMFCnumber,
        dimensions: {
          length: 0,
          width: 0,
          height: 0,
          dimensionsUom: 'cm',
          isStackable: false
        }
      }
    ];

    setFinalCommodityInfoApi(CommodityInfoApi);
  };
  const [BOLNumber, setBOLNumber] = useState('');
  const [, setPoRefNumber] = useState('');
  const [carriersLoader, setCarriersLoader] = useState(true);
  const [deliveryRemarks, setDeliveryRemarks] = useState('');
  const [pickupRemarks, setPickupRemarks] = useState('');
  const [overLengthValue, setOverLengthValue] = useState('');
  const [CODAmount, setCODAmount] = useState(
    PreviousProps?.codAmount ? String(PreviousProps.codAmount) : ''
  );
  const [DeclaredValue, setDeclaredValue] = useState(
    PreviousProps?.declaredValue ? String(PreviousProps.declaredValue) : ''
  );
  const [hazmatSwitch, setHazmatSwitch] = useState(false);
  const [insidePickupSwitch, setInsidePickupSwitch] = useState(false);
  const [liftgatePickupSwitch, setLiftgatePickupSwitch] = useState(false);
  const [residentialPickupSwitch, setResidentialPickupSwitch] = useState(false);
  const [secureAccesPickupSwitch, setSecureAccesPickupSwitch] = useState(false);
  const [limitedPickupAccessSwitch, setLimitedPickupAccessSwitch] =
    useState(false);
  const [freezeProtectionPickupSwitch, setFreezeProtectionPickupSwitch] =
    useState(false);
  const [overlengthPickupSwitch, setOverlengthPickupSwitch] = useState(false);
  //delivery switch states
  const [insideDeliverySwitch, setInsideDeliverySwitch] = useState(false);
  const [liftgateDeliverySwitch, setLiftgateDeliverySwitch] = useState(false);
  const [residentialDeliverySwitch, setResidentialDeliverySwitch] =
    useState(false);
  const [limitedDeliverySwitch, setLimitedDeliverySwitch] = useState(false);
  const [secureAccesDeliverySwitch, setSecureAccesDeliverySwitch] =
    useState(false);
  const [
    callBeforeDeliveryServicesSwitch,
    setCallBeforeDeliveryServicesSwitch
  ] = useState(false);

  const [reloadQuote] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedCarrierIDQuoteRates, setSelectedCarrierIDQuoteRates] =
    useState('');
  const [selectedPickupdate, setSelectedPickupdate] = useState('');
  const [selectedDeliveryDate, setSelectedDeliveryDate] = useState('');
  const [selectedCarrierQuotaionID, setSelectedCarrierQuotaionID] =
    useState('');
  const [TLdate, setTLDate] = useState('');
  const [selectedCarrierNameQuoteRates, setSelectedCarrierNameQuoteRates] =
    useState('');

  const [carriers, setCarriers] = useState([]);
  const [selectedCarriersIdArray, setSelectedCarriersIdArray] = useState([]);
  const [carriersFinalArray, setCarriersFinalArray] = useState([]);
  const [enableNext, setEnableNext] = useState(false);
  const [, setTLcarriers] = useState([]);
  const [TankerCarriers, setTankerCarriers] = useState([]);
  const [dryVanCarriers, setDryVanCarriers] = useState([]);
  const [reeferCarriers, setReeferCarriers] = useState([]);
  const [, setflatBedCarriers] = useState([]);
  const [sprinterCarriers, setSprinterCarriers] = useState([]);
  const [boxTruckCarriers, setBoxTruckCarriers] = useState([]);
  const [railIntermodalCarriers, setRailIntermodalCarriers] = useState([]);
  const [, setPickupContactLoaderId] = useState(null);
  const [, setDisabledPickupId] = useState(null);
  const [, setDeliveryContactLoaderId] = useState(null);
  const [, setDisabledDeliveryId] = useState(null);
  const [pickupInstContent, setPickupInstContent] = useState('');
  const [allCarriersChecked, setAllCarriersChecked] = useState(false);
  const [TLQuoteId, setTLQuoteId] = useState(
    previousQuoteId?.quoteId ? previousQuoteId?.quoteId : null
  );
  const [quoteNumber, setQuoteNumber] = useState(
    PreviousProps?.quoteNumber ? PreviousProps?.quoteNumber : ''
  );
  const [equipmentType, setEquipmentType] = useState('');
  const [quoteMode, setQuoteMode] = useState(
    PreviousProps?.TLPickupMode ? PreviousProps?.TLPickupMode : ''
  );
  const [driverType, setDriverType] = useState('');
  const [dilveryInstContent, setDilveryInstContent] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [ApiFailed, setApiFailed] = useState(false);
  const [ApiErrorMessage, setApiErrorMessage] = useState('');
  const [, setHasEffectRun] = useState(false);
  const [shipmentsDetails, setShipmentsDetails] = useState(
    PreviousProps?.details ? PreviousProps?.details : []
  );
  const [pickupValidationErrors, setPickupValidationErrors] = useState([]);
  const [currentValidationIndex, setCurrentValidationIndex] = useState(null);
  const [pickupDetailsArr, setPickupDetailsArr] = useState([]);
  const [deliveryDetailsArr, setDeliveryDetailsArr] = useState([]);
  const [, setTabChangeConfrim] = useState(false);
  const [tabChangeDialog, setTabChangeDialog] = useState(false);
  const [searchCarrier, setSearchCarrier] = useState('');
  const [reeferTemp, setReeferTemp] = useState(
    PreviousProps.temperature || PreviousProps.extra2 || 0
  );
  const [reeferTempUnit, setReeferTempUnit] = useState(() => {
    const raw = PreviousProps?.unit || PreviousProps?.extra3;
    if (!raw) return '°F';
    return raw.replace(/&#xB0;/gi, '°').replace(/&deg;/gi, '°');
  });
  const [originInfo] = useState({
    contactPerson: PreviousProps?.originContactPerson
      ? PreviousProps.originContactPerson
      : '',
    contactCompany: PreviousProps?.originCompany
      ? PreviousProps?.originCompany
      : '',
    contactAddress: PreviousProps?.originAddress
      ? PreviousProps?.originAddress
      : '',
    contactPhone: PreviousProps?.originContactPhone
      ? PreviousProps?.originContactPhone
      : '',
    contactEmail: PreviousProps?.originContactEmail
      ? PreviousProps?.originContactEmail
      : ''
  });

  const [destinationInfo] = useState({
    contactPerson: PreviousProps?.destinationContactPerson
      ? PreviousProps?.destinationContactPerson
      : '',
    contactCompany: PreviousProps?.destinationCompany
      ? PreviousProps?.destinationCompany
      : '',
    contactAddress: PreviousProps?.destinationAddress
      ? PreviousProps?.destinationAddress
      : '',
    contactPhone: PreviousProps?.destinationContactPhone
      ? PreviousProps?.destinationContactPhone
      : '',
    contactEmail: PreviousProps?.destinationContactEmail
      ? PreviousProps?.destinationContactEmail
      : '',
    contactEmail2: PreviousProps?.destinationContactEmail
      ? PreviousProps?.destinationContactEmail
      : ''
  });
  const deliveryCompanyRefs = useRef([]);
  const deliveryPhoneRefs = useRef([]);

  // Validation state
  const [deliveryValidationErrors, setDeliveryValidationErrors] = useState([]);
  const [deliveryCurrentValidationIndex, setDeliveryCurrentValidationIndex] =
    useState(null);
  const companyRefs = useRef([]);
  const phoneRefs = useRef([]);

  const userRolePermissions = useSelector(
    state => state.userDetails.userRolePermissionsArr
  );

  useEffect(() => {
    const filteredCarrierPermissions = userRolePermissions?.filter(
      items => items.permissionName === 'Carriers'
    );
    setUserPermissionsArr(filteredCarrierPermissions);
  }, [userRolePermissions]);

  const carrierMap = {
    0: 'Bulk Tanker',
    1: 'Dry Van 53ft',
    2: 'Reefer',
    3: 'Box Truck',
    4: 'Sprinter',
    5: 'Intermodal' // default/fallback
  };

  const activeTab = (value, activeCarrierName) => {
    console.log(value, activeCarrierName, 'check active tabs');
    if (activeCarrierName !== '') {
      // Return value (number) based on carrier name
      const foundEntry = Object.entries(carrierMap).find(
        ([key, name]) => name === activeCarrierName
      );
      return foundEntry ? Number(foundEntry[0]) : null; // null if not found
    }

    // Return carrier name based on value
    return carrierMap[value] || 'Intermodal';
  };

  const handleConfimrTabChange = newValue => {
    setValue(newValue);
    console.log(newValue, 'newValue');
    // setTabChangeDialog(false);
    if (newValue === 0) {
      const tankerInactiveCarriers = TankerCarriers.map(TlCarriers => ({
        ...TlCarriers,
        active: false
      }));

      setCarriers(tankerInactiveCarriers);
    }
    if (newValue === 1) {
      const DryVanInactiveCarriers = dryVanCarriers.map(TlCarriers => ({
        ...TlCarriers,
        active: false
      }));

      setCarriers(DryVanInactiveCarriers);
    }
    if (newValue === 2) {
      const ReeferInactiveCarriers = reeferCarriers.map(TlCarriers => ({
        ...TlCarriers,
        active: false
      }));

      setCarriers(ReeferInactiveCarriers);
    }
    if (newValue === 3) {
      const BoxTruckInactiveCarriers = boxTruckCarriers.map(TlCarriers => ({
        ...TlCarriers,
        active: false
      }));

      setCarriers(BoxTruckInactiveCarriers);
    }
    if (newValue === 4) {
      const SprinterInactiveCarriers = sprinterCarriers.map(TlCarriers => ({
        ...TlCarriers,
        active: false
      }));

      setCarriers(SprinterInactiveCarriers);
    }
    if (newValue === 5) {
      const IntermoalInactiveCarriers = railIntermodalCarriers.map(
        TlCarriers => ({
          ...TlCarriers,
          active: false
        })
      );

      setCarriers(IntermoalInactiveCarriers);
    }
  };

  useEffect(() => {
    setValue(activeTab(null, PreviousProps?.equipmentType));
    // handleConfimrTabChange(activeTab(null, PreviousProps?.equipmentType));
  }, [PreviousProps?.equipmentType]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const inActiveCarrier = carriers.find(items => items.active === false);
    if (!inActiveCarrier && tabChanged && carriers.length !== 0) {
      setAllCarriersChecked(true);
    } else {
      setAllCarriersChecked(false);
    }
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps

  const filteredCarriers = useMemo(() => {
    if (!searchCarrier) return carriers;

    return carriers.filter(carrier =>
      carrier.name?.toLowerCase().includes(searchCarrier.toLowerCase())
    );
  }, [searchCarrier, carriers]);

  const handleViewTLRates = useCallback(ApiData => {
    setPickUpLoader(false);
    setApiFailed(false);

    setPickupInstContent(ApiData?.pickupInstructions);
    setPickupRemarks(ApiData?.pickupInstructions);
    setDeliveryRemarks(ApiData?.deliveryInstructions);
    setDilveryInstContent(ApiData?.deliveryInstructions);

    setOriginOpenTimeValue(ApiData?.pickupOpenTime);
    setOriginCloseTimeValue(ApiData?.pickupCloseTime);
    setDestinationOpenTimeValue(ApiData?.deliveryOpenTime);
    setDestinationCloseTimeValue(ApiData?.deliveryCloseTime);

    setQuoteNumber(ApiData?.quoteNumber);
    setEquipmentType(ApiData?.equipmentType);
    setReeferTemp(ApiData?.temperature);
    setReeferTempUnit(ApiData?.temperatureUnit);
    setQuoteMode(ApiData?.quoteMode);
    setDriverType(ApiData?.serviceType || ApiData?.driverType || '');

    setCarriers(ApiData?.quoteCarriers || []);

    const respondedCarrier = [];
    const carriersFinalArray2 = [];

    ApiData?.quoteCarriers?.forEach(carrier => {
      if (
        carrier.carrierResponseStatus === 'RESPONDED' &&
        !respondedCarrier.includes(carrier.carrierID)
      ) {
        respondedCarrier.push(carrier.carrierID);
      }

      if (carrier.active) {
        carriersFinalArray2.push(carrier);
      }
    });

    setCarriersFinalArray(carriersFinalArray2);
    setHasEffectRun(true);
    setIsLoading(false);
  }, []);

  const handleListItemClick = useCallback((event, index, items) => {
    setCarrierName(items.carrierName);
    setSelectedCarrierNameQuoteRates(items.quoteValue);
    setSelectedCarrierIDQuoteRates(items.sessionId);
    setSelectedIndex(index);
    setSelectedCarrierQuotaionID(items.referenceNumber);
    setTLDate(items.deliveryDate);
    setSelectedPickupdate(items.quotePickupDate);
    setSelectedDeliveryDate(items.deliveryDate);

    return false;
  }, []);

  const handleSuccessCarriers = useCallback(
    ApiRes => {
      setCarriersLoader(false);

      const carriersArray = ApiRes?.data?.data || [];

      const grouped = {
        TL: [],
        tanker: [],
        dryVan: [],
        reefer: [],
        flatBed: [],
        sprinter: [],
        boxTruck: [],
        railIntermodal: []
      };

      carriersArray.forEach(item => {
        item.active = false;

        if (item.cType === 'TL') grouped.TL.push(item);
        if (item.cSubType?.includes('Bulk Tanker')) grouped.tanker.push(item);
        if (item.cSubType?.includes('Dry Van')) grouped.dryVan.push(item);
        if (item.cSubType?.includes('Reefer')) grouped.reefer.push(item);
        if (item.cSubType?.includes('Flat Bed')) grouped.flatBed.push(item);
        if (item.cSubType?.includes('Sprinter')) grouped.sprinter.push(item);
        if (item.cSubType?.includes('Box Truck')) grouped.boxTruck.push(item);
        if (item.cSubType?.includes('Intermodal'))
          grouped.railIntermodal.push(item);
      });

      const selectedValue = activeTab(null, PreviousProps?.equipmentType);

      const carrierMap = {
        0: grouped.tanker,
        1: grouped.dryVan,
        2: grouped.reefer,
        3: grouped.boxTruck,
        4: grouped.sprinter
      };

      setCarriers(carrierMap[selectedValue] || grouped.railIntermodal);

      // Set all grouped states
      setTLcarriers(grouped.TL);
      setTankerCarriers(grouped.tanker);
      setDryVanCarriers(grouped.dryVan);
      setReeferCarriers(grouped.reefer);
      setSprinterCarriers(grouped.sprinter);
      setflatBedCarriers(grouped.flatBed);
      setBoxTruckCarriers(grouped.boxTruck);
      setRailIntermodalCarriers(grouped.railIntermodal);
    },
    [activeTab, PreviousProps?.equipmentType] // eslint-disable-line react-hooks/exhaustive-deps
  );

  const handleSynchRatesRequest = useCallback(
    latestApiRes => {
      setIsLoading(true);

      handleViewTLRates(latestApiRes);

      GetActiveCarriers(AgencyID, previousQuoteId.locationId)
        .then(res => {
          if (res?.status === 200) {
            handleSuccessCarriers(res);
          }
        })
        .catch(err => {
          ErrorToast(err?.message);
        });
    },
    [
      AgencyID,
      previousQuoteId.locationId,
      handleViewTLRates,
      handleSuccessCarriers,
      setIsLoading
    ]
  );

  const rando = max => Math.floor(Math.random() * max);
  const words = ['Paper', 'Rock', 'Scissors'];
  const rawData = [];

  for (let i = 0; i < 100; i++)
    rawData.push({ id: rando(300), name: words[i % words.length] });

  const handleResetAllData = () => {
    handleReset();
    setCarrierName(null);
    setPickupNumber('');
    setProNumber('');
    setOriginOpenTimeValue('');
    setOriginCloseTimeValue('');
    setDestinationDate(new Date());
    setDestinationOpenTimeValue('');
    setDestinationCloseTimeValue('');
    setPaymentType('');
    setBOLNumber('');
    setHazmatSwitch(!hazmatSwitch);
    setDeliveryRemarks('');
    setPickupRemarks('');
    setInsidePickupSwitch(false);
    setLiftgatePickupSwitch(false);
    setResidentialPickupSwitch(false);
    setSecureAccesPickupSwitch(false);
    setLimitedPickupAccessSwitch(false);
    setFreezeProtectionPickupSwitch(false);
    setOverlengthPickupSwitch(false);
    setOverLengthValue('');
    setInsideDeliverySwitch(false);
    setLiftgateDeliverySwitch(false);
    setResidentialDeliverySwitch(false);
    setSecureAccesDeliverySwitch(false);
    setLimitedDeliverySwitch(false);
    setCallBeforeDeliveryServicesSwitch(false);
    setCODAmount('');
    setDeclaredValue('');
  };

  const descriptionElementRef = useRef(null);

  useEffect(() => {
    GetActiveCarriers(AgencyID, previousQuoteId.locationId)
      .then(res => res.status === 200 && handleSuccessCarriers(res))
      .catch(err => {
        ErrorToast(err?.message);
        // setCarriersLoader(false);
      });
    PreviousProps.quoteId !== 0 &&
      props?.location?.state?.disptachOpen === 'Get Quote' &&
      isQuickQuoteRate &&
      handleNext(activeStep);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  // Update the runtime state directly
  const updateRuntimeState = () => {
    UpdatedStoredServices.current = {
      insideDeliverySwitch: insideDeliverySwitch,
      liftgateDeliverySwitch: liftgateDeliverySwitch,
      residentialDeliverySwitch: residentialDeliverySwitch,
      secureAccesDeliverySwitch: secureAccesDeliverySwitch,
      limitedDeliverySwitch: limitedDeliverySwitch,
      callBeforeDeliveryServicesSwitch: callBeforeDeliveryServicesSwitch,
      insidePickupSwitch: insidePickupSwitch,
      liftgatePickupSwitch: liftgatePickupSwitch,
      residentialPickupSwitch: residentialPickupSwitch,
      secureAccesPickupSwitch: secureAccesPickupSwitch,
      limitedPickupAccessSwitch: limitedPickupAccessSwitch,
      freezeProtectionPickupSwitch: freezeProtectionPickupSwitch,
      overlengthPickupSwitch: overlengthPickupSwitch,
      hazmatSwitch: hazmatSwitch,
      CODAmount: CODAmount,
      DeclaredValue: DeclaredValue,
      OverLengthValue: overLengthValue
    };
    // No re-render will be triggered
  };

  useEffect(() => {
    updateRuntimeState();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    let status = carriers.find(items => items.active);
    if (status) {
      setEnableNext(false);
    } else setEnableNext(true);
  }, [carriers]);

  const [validationErrors, setValidationErrors] = useState({});
  const [activeStep, setActiveStep] = useState(
    1
    // PreviousProps.quoteId !== 0 ? 1 :
    // PreviousProps.quoteId !== 0 &&
    //   props?.location?.state?.disptachOpen === 'Get Quote' &&
    //   props?.location?.state?.rateType !== 'Quick Quote'
    //   ? 1
    //   : 0
  );
  const [activeTabLabel] = useState('origin');
  const DispatchApiResHandler = ApiRes => {
    setPickUpLoader(false);
    if (ApiRes?.status === 200) {
      setShipmentDispatchMsg(ApiRes?.data?.data?.status);
      setShipmentDispatchFailed(false);
    } else {
      setShipmentDispatchMsg('');
      setShipmentDispatchFailed(true);
    }
  };
  const CallDispatchShipmentApi = () => {
    // alert('called');
    setPickUpLoader(true);

    const DispatchObj = {
      shipmentId: JSON.parse(props?.location?.state?.pickupRowData).shipmentId
        ? JSON.parse(props?.location?.state?.pickupRowData).shipmentId
        : 0,
      agencyId: AgencyID ? AgencyID : 0,
      type: 0,
      proNumber: proNumber ? proNumber : '',
      bolNumber: BOLNumber ? BOLNumber : '',
      refNumber: refOrQuoteNmb ? refOrQuoteNmb : '',
      pickupNumber: pickupNumber ? pickupNumber : '',
      carrierId: JSON.parse(props?.location?.state?.pickupRowData).carrierId
        ? JSON.parse(props?.location?.state?.pickupRowData).carrierId
        : 0,
      carrierName: JSON.parse(props?.location?.state?.pickupRowData).carrierName
        ? JSON.parse(props?.location?.state?.pickupRowData).carrierName
        : otherCarrierName
          ? otherCarrierName
          : '',
      driverName: driverName ? driverName : '',
      vehicleNumber: truckNumber ? truckNumber : '',
      phoneNumber: ''
    };
    DispatchShipment(DispatchObj)
      .then(res => DispatchApiResHandler(res))
      .catch(err => DispatchApiResHandler(err));
  };
  const getShipementDetails = shipId => {
    GetShipmentDetails(shipId)
      .then(res => {
        if (res.status === 200) {
          const allDetails = res.data.data;
          setPickupDetailsArr(
            allDetails.filter(item => item.itemType === 'Pickup')
          );
          setDeliveryDetailsArr(
            allDetails.filter(item => item.itemType === 'Delivery')
          );
          setShipmentsDetails(allDetails);
        }
      })
      .catch(err => ErrorToast('Get Shipment Details API failed'));
  };

  const { groupedPickupDetails, groupedDeliveryDetails } = useMemo(() => {
    const groupByAddress = arr => {
      return arr.reduce((acc, item) => {
        const key = `${item.address}-${item.city}-${item.state}-${item.zip}-${item.country}`;
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
      }, {});
    };

    return {
      groupedPickupDetails: groupByAddress(pickupDetailsArr),
      groupedDeliveryDetails: groupByAddress(deliveryDetailsArr)
    };
  }, [pickupDetailsArr, deliveryDetailsArr]);

  const handleQuoteDetailReq = apiRes => {
    setIsLoading(true);
    setTLQuoteId(apiRes);
    GetQuote(apiRes)
      .then(res => res.status === 200 && handleViewTLRates(res.data.data))
      .catch(err => {
        setApiFailed(true);
        setCarriers([]);
        setCarriersFinalArray([]);
        setIsLoading(false);
        console.log(err, 'TL quote Err----->>>>');
        setApiErrorMessage(err?.message);
      });
  };

  const handleTLShipmentReq = shipmentId => {
    const startTLQuoteObj = {
      shipmentId: shipmentId
        ? shipmentId
        : PreviousProps?.shipmentId
          ? PreviousProps?.shipmentId
          : 0,
      pickupDate: PreviousProps?.pickupDate ?? '',
      pickupInstructions: pickupRemarks ? pickupRemarks : '',
      pickupOpenTime: originOpenTimeValue ?? '',
      pickupCloseTime: originCloseTimeValue ?? '',
      estimatedDeliveryDate: PreviousProps?.deliveryDate ?? '',
      deliveryInstructions: deliveryRemarks ? deliveryRemarks : '',
      deliveryOpenTime: destinationOpenTimeValue ?? '',
      deliveryCloseTime: destinationCloseTimeValue ?? '',
      carriers: selectedCarriersIdArray,
      agencyId: AgencyID,
      locationId: PreviousProps?.locationId ? PreviousProps?.locationId : 0,
      weight: PreviousProps?.totalGrossWeight
        ? PreviousProps?.totalGrossWeight
        : 0,
      pallets: 0,
      cargoValue: PreviousProps?.cargoValue ? PreviousProps?.cargoValue : 0,
      temperature: Number(reeferTemp),
      temperatureUnit: reeferTempUnit,
      quoteMode: PreviousProps?.TLPickupMode ?? PreviousProps?.extra1 ?? '',
      equipmentType: activeTab(value, '') ?? '',
      driverType: PreviousProps?.serviceType ?? ''
    };
    PreviousProps?.quoteId === 0 &&
      TLQuoteId === null &&
      StartTLQuote(startTLQuoteObj)
        .then(res => {
          if (res.status === 200) {
            handleQuoteDetailReq(res.data.data?.quoteId);
            setQuoteNumber(res.data.data?.quoteNumber);
          }
        })
        .catch(err => {
          setApiFailed(true);
          setCarriers([]);
          setCarriersFinalArray([]);
          setIsLoading(false);
          console.log(err, 'TLErr');
          setApiErrorMessage(err?.message);
        });
  };
  const handleStartTLRequest = () => {
    // const saveShipmentObj = PreviousProps;
    // PreviousProps.shippingNotes = pickupRemarks;
    // PreviousProps.equipmentType = selectedCarriersIdArray[0]?.cSubType;
    // PreviousProps.orderDate = PreviousProps.orderDate;
    // PreviousProps.pickupDate = PreviousProps.pickupDate;
    // PreviousProps.deliveryDate = PreviousProps.deliveryDate;
    // PreviousProps.ExpectedDeliveryDate = PreviousProps.ExpectedDeliveryDate;
    // PreviousProps.actualPickupDate = PreviousProps.actualPickupDate;
    // PreviousProps.actualDeliveryDate = PreviousProps.actualDeliveryDate;
    // PreviousProps.pickupStartTime = originOpenTimeValue;
    // PreviousProps.pickupEndTime = originCloseTimeValue;
    // PreviousProps.deliverStartTime = destinationOpenTimeValue;
    // PreviousProps.deliverEndTime = destinationCloseTimeValue;
    function normalizeDatesDeep(obj) {
      if (Array.isArray(obj)) {
        return obj.map(normalizeDatesDeep);
      } else if (obj && typeof obj === 'object') {
        const newObj = {};
        for (const key in obj) {
          const value = obj[key];

          // Check if value looks like a date string (ISO)
          if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(value)) {
            // Convert to local date string without shifting timezones
            const d = new Date(value);
            // getTimezoneOffset() gives minutes to subtract to get local time
            const local = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
            newObj[key] = local.toISOString().split('T')[0]; // keep YYYY-MM-DD only
          } else if (value instanceof Date) {
            const local = new Date(
              value.getTime() - value.getTimezoneOffset() * 60000
            );
            newObj[key] = local.toISOString().split('T')[0];
          } else {
            newObj[key] = normalizeDatesDeep(value);
          }
        }
        return newObj;
      }
      return obj;
    }

    setPickUpLoader(true);
    const safeObj = normalizeDatesDeep(props?.location?.state?.createshipObj);
    console.log(props?.location?.state, 'safeObj');
    const payload = safeObj ? safeObj : PreviousProps;
    if (value === 2) {
      payload.temperature = reeferTemp;
      payload.unit = reeferTempUnit;
    }
    CreateShipment(payload)
      .then(res => {
        res.status === 200 && console.log(res, 'res of create ship');
        setPickUpLoader(false);

        if (res.status === 200) {
          setCreatedShipmentId(res.data.data);
          handleTLShipmentReq(res.data.data); // this runs only if status === 200
        }
      })
      .catch(err => {
        setPickUpLoader(false);
        ErrorToast(err?.response?.data ? err?.response?.data : err?.message);
        console.log(err, 'Create SHipment Error_____________>>>>');
      });
  };
  const handleNext = index => {
    setNegotiateRate(false);
    let errors = {};

    if (index === 0 && props?.location?.state?.disptachOpen !== 'Get Quote') {
      if (
        carrierName == null &&
        !otherCarrierName &&
        PreviousProps?.shipmentStatus !== 'Booked'
      ) {
        errors['carrierName'] = 'Select carrier Name';
      } else if (!refOrQuoteNmb) {
        errors['refOrQuoteNmbErr'] = 'Enter Quote Number';
      } else setActiveStep(prevActiveStep => prevActiveStep + 1);
    } else if (index === 1) {
      let tempIDs = [];
      let carriersFinalArray = [];
      if (props?.location?.state?.disptachOpen === 'Get Quote') {
        for (let i = 0; i < carriers.length; i++) {
          const currentStatus = carriers[i].active;
          const item = carriers[i];
          const carrierID = carriers[i].carrierId;
          const cSubType = PreviousProps?.equipmentType;

          currentStatus &&
            tempIDs.push({ carrierId: carrierID, cSubType: cSubType });
          currentStatus && carriersFinalArray.push(item);
        }
        setSelectedCarriersIdArray(tempIDs);
        setCarriersFinalArray(carriersFinalArray);

        setTimeout(() => {
          quoteType === 'Quick Quote'
            ? handleStartTLRequest()
            : handleTLShipmentReq();
        }, 20);
        if (!originOpenTimeValue) {
          errors['originOpenTime'] = 'Select pickup open time';
        } else if (!originCloseTimeValue) {
          errors['originCloseTime'] = 'Select pickup close time';
        }
        // else if (!pickupRemarks) {
        //   errors['pickupRemarks'] = 'Enter pickup remarks';
        // }
        else if (!destinationOpenTimeValue) {
          errors['destinationOpenTime'] = 'Select delivery open time';
        } else if (!destinationCloseTimeValue) {
          errors['destinationCloseTime'] = 'Select delivery close time';
        }
        // else if (!deliveryRemarks) {
        //   errors['deliveryRemarks'] = 'Enter delivery remarks';
        // }
        else setActiveStep(prevActiveStep => prevActiveStep + 1);
      } else if (!destinationOpenTimeValue) {
        errors['destinationOpenTime'] = 'Select delivery open time';
      } else if (!destinationCloseTimeValue) {
        errors['destinationCloseTime'] = 'Select delivery close time';
      }

      // else if (!deliveryRemarks) {
      //   errors['deliveryRemarks'] = 'Enter delivery remarks';
      // }
      else setActiveStep(prevActiveStep => prevActiveStep + 1);
    } else if (index === 2) {
      getShipementDetails(createdShipmentId);
      setActiveStep(prevActiveStep => prevActiveStep + 1);
    } else if (index === 3) {
      // Validate pickup details
      // Validate pickup details first
      let hasPickupError = false;
      for (const [key] of Object.entries(groupedPickupDetails)) {
        const groupIndex = Object.keys(groupedPickupDetails).indexOf(key);
        const pickupItem = pickupDetailsArr[groupIndex];

        if (pickupItem) {
          let errors = {
            company:
              PreviousProps?.freightTerms === 'OutboundPrepaid' &&
              !pickupItem.company?.trim()
                ? 'Company name is required'
                : '',
            contactPhone: !pickupItem.contactPhone?.trim()
              ? 'Phone number is required'
              : ''
          };

          if (errors.company || errors.contactPhone) {
            const tempErrors = [];
            tempErrors[groupIndex] = errors;
            setPickupValidationErrors(tempErrors);
            setCurrentValidationIndex(groupIndex);

            setTimeout(() => {
              if (errors.company) {
                companyRefs.current[groupIndex]?.focus();
              } else if (errors.contactPhone) {
                phoneRefs.current[groupIndex]?.focus();
              }
            }, 0);

            hasPickupError = true;
            break; // Stop at first pickup error
          } else {
            handleUpdateContactDetails('Pickup', '', '', pickupDetailsArr);
          }
        }
      }

      // Only validate delivery if no pickup errors
      console.log(hasPickupError, 'hasPickupError');
      if (!hasPickupError) {
        let hasDeliveryError = false;
        for (const [key] of Object.entries(groupedDeliveryDetails)) {
          const groupIndex = Object.keys(groupedDeliveryDetails).indexOf(key);
          const deliveryItem = deliveryDetailsArr[groupIndex];

          if (deliveryItem) {
            let errors = {
              company:
                PreviousProps?.freightTerms === 'InboundCollect' &&
                !deliveryItem.company?.trim()
                  ? 'Company name is required'
                  : '',
              contactPhone: !deliveryItem.contactPhone?.trim()
                ? 'Phone number is required'
                : ''
            };

            if (errors.company || errors.contactPhone) {
              const tempErrors = [];
              tempErrors[groupIndex] = errors;
              setDeliveryValidationErrors(tempErrors);
              setDeliveryCurrentValidationIndex(groupIndex);

              setTimeout(() => {
                if (errors.company) {
                  deliveryCompanyRefs.current[groupIndex]?.focus();
                } else if (errors.contactPhone) {
                  deliveryPhoneRefs.current[groupIndex]?.focus();
                }
              }, 0);

              hasDeliveryError = true;
              break; // Stop at first delivery error
            } else {
              handleUpdateContactDetails(
                'Delivery',
                '',
                '',
                deliveryDetailsArr
              );
            }
          }
        }

        // Only check sale order number if no pickup or delivery errors
        // if (!hasDeliveryError && !saleOrderNumber) {
        //   errors['saleOrderNumberError'] = 'Enter Shipment #';
        //   enterSONumber?.current?.focus();
        // }
        if (!hasDeliveryError && !customerPoNmb) {
          errors['customerPoNmbError'] = 'Enter customer PO #';
          enterPONumber?.current?.focus();
        }
      }

      if (customerPoNmb) {
        setPickUpLoader(true);

        const bookTLobj = {
          sessionId: selectedCarrierIDQuoteRates,
          charges: selectedCarrierNameQuoteRates,
          pickupNumber: selectedCarrierQuotaionID,
          estimatedDeliveryDate: TLdate,
          pickupDate: selectedPickupdate,
          comments: '',
          soNumber: saleOrderNumber ? saleOrderNumber : '',
          poNumber: customerPoNmb ? customerPoNmb : '',
          originCompany:
            pickupDetailsArr[0]?.company || originInfo?.contactCompany,
          originAddress: originInfo?.contactAddress,
          originCity: PreviousProps?.originCity,
          originState: PreviousProps?.originState,
          originZip: PreviousProps?.originZip || PreviousProps?.originZipCode,
          originCountry: PreviousProps?.originCountry,
          originContactPerson:
            pickupDetailsArr[0]?.contactPerson || originInfo?.contactPerson,
          originContactEmail:
            pickupDetailsArr[0]?.contactEmail || originInfo?.contactEmail,
          originContactPhone: formatPhoneNumber(
            pickupDetailsArr[0]?.contactPhone || originInfo?.contactPhone
          ),
          destinationCompany:
            deliveryDetailsArr[0]?.company || destinationInfo?.contactCompany,
          destinationAddress: destinationInfo?.contactAddress,
          destinationCity: PreviousProps?.destinationCity,
          destinationState: PreviousProps?.destinationState,
          destinationZip:
            PreviousProps?.destinationZip || PreviousProps?.destinationZipCode,
          destinationCountry: PreviousProps?.destinationCountry,
          destinationContactPerson:
            deliveryDetailsArr[0]?.contactPerson ||
            destinationInfo?.contactPerson,
          destinationContactEmail:
            deliveryDetailsArr[0]?.contactEmail ||
            destinationInfo?.contactEmail,
          destinationContactPhone: formatPhoneNumber(
            deliveryDetailsArr[0]?.contactPhone || destinationInfo?.contactPhone
          )
        };
        BookTLShipment(bookTLobj)
          .then(res => {
            res.status === 200 && setPickUpLoader(false);
            setShipmentBooked(true);
            setShipmentDispatchFailed(false);
          })
          .catch(err => {
            console.log(err, 'check book ship failuer error');
            setShipmentFailedMsg(
              err?.response?.data ? err?.response?.data : err?.message
            );
            setPickUpLoader(false);
            setShipmentBooked(false);
            setShipmentDispatchFailed(true);
          });
        setActiveStep(prevActiveStep => prevActiveStep + 1);
      }
    } else setActiveStep(prevActiveStep => prevActiveStep + 1);
    // setSelectedIndex(null);
    // sessionStorage.setItem('updatedStoredServices', null);

    setValidationErrors(errors);
    // if (
    //     props?.location?.state?.disptachOpen === 'Get Quote' &&
    //     activeStep === 2
    // ) {
    //     CallPickupApi();
    // }
    if (
      props?.location?.state?.disptachOpen !== 'Get Quote' &&
      stepsArray().length === 2 &&
      index === 1
    ) {
      CallDispatchShipmentApi();
    }
  };

  const handleBack = () => {
    if (activeStep === 1) {
      history.push('/quick-quote');
    }
    if (activeStep === 2) {
      setAllCarriersChecked(false);
      setValue(0);
      setTLQuoteId(null);
      setQuoteType('Quick Quote');
      GetActiveCarriers(AgencyID, previousQuoteId.locationId)
        .then(res => {
          res.status === 200 && setNegotiateRate(false);
          setActiveStep(prevActiveStep => prevActiveStep - 1);
          handleSuccessCarriers(res);
        })
        .catch(err => {
          ErrorToast(err?.message);
          // setCarriersLoader(false);
        });
    } else {
      setNegotiateRate(false);
      setActiveStep(prevActiveStep => prevActiveStep - 1);
    }
  };

  const handleReset = () => {
    setActiveStep(3);
  };

  const PaymentTypeArr = ['Outbound Prepaid', 'Third Party'];
  const [, setPaymentType] = useState(PreviousProps?.paymentTerms);

  const handleClassInputChange = (inputName, index, event) => {
    let totalWeight = 0;
    let TotalWeightSum;
    const values = [...newAddedClassRow];
    if (inputName === 'WeightLBS') {
      // const updatedErrors = { ...validationErrors, weightLBS: null };
      // setValidationErrors(updatedErrors);

      values[index].WeightLBS = event.target.value;

      for (let index = 0; index < newAddedClassRow.length; index++) {
        if (newAddedClassRow[index].WeightLBS !== '') {
          totalWeight += parseInt(newAddedClassRow[index].WeightLBS);
        }
      }
      setTotalLBSWeightClass(totalWeight);
      TotalWeightSum = totalLBSWeightDimensions
        ? parseInt(totalLBSWeightDimensions) + totalWeight
        : totalWeight;
      setTotalWeightSum(TotalWeightSum);
      handlePushAddedCommodityInfo(TotalWeightSum);
    } else if (inputName === 'NMFCnumber') {
      values[index].NMFCnumber = event.target.value;
    } else if (inputName === 'Class') {
      values[index].Class = event === null ? ClassArray[0] : event;
    }

    setNewAddedClassRow(values);
  };

  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  const [, setNegotiateRate] = useState(false);

  const handleNegotiateRate = useCallback(() => {
    setNegotiateRate(true);
  }, []);
  const detectBrowser = () => {
    const userAgent = navigator.userAgent;
    let browser = '';

    if (userAgent.indexOf('Firefox') > -1) {
      browser = 'Firefox';
    } else if (userAgent.indexOf('Chrome') > -1) {
      browser = 'Chrome';
    } else {
      browser = 'Unknown';
    }

    return browser;
  };

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  function formatPhoneNumber(value) {
    const cleaned = value.replace(/\D/g, ''); // keep only digits
    const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);

    if (!match) return value;

    let formatted = '';
    if (match[1]) formatted = `(${match[1]}`;
    if (match[2]) formatted += `) ${match[2]}`;
    if (match[3]) formatted += `-${match[3]}`;
    return formatted;
  }

  const checkAllSelected = () => {
    let tempIDs = [];

    const allActive = carriers.every(items => items.active);
    for (let i = 0; i < carriers.length; i++) {
      const currentStatus = carriers[i].active;
      const item = carriers[i];
      const carrierID = carriers[i].carrierId;
      const cSubType = PreviousProps?.equipmentType;

      currentStatus &&
        tempIDs.push({ carrierId: carrierID, cSubType: cSubType });
      currentStatus && carriersFinalArray.push(item);
    }
    setSelectedCarriersIdArray(tempIDs);

    if (allActive) {
      setAllCarriersChecked(true);
    } else {
      setAllCarriersChecked(false);
    }
  };
  const browser = detectBrowser();

  const handleUpdateContactDetails = (type, shipDetailsId, index, group) => {
    const {
      contactPerson = '',
      company = '',
      contactPhone = '',
      contactEmail = ''
    } = group[0];
    const updated = group.map(item => ({
      ...item,
      contactPerson,
      company,
      contactPhone,
      contactEmail
    }));

    const wait = ms => new Promise(resolve => setTimeout(resolve, ms));

    const updateSequentially = async () => {
      for (const element of updated) {
        try {
          const res = await UpdateShipmentDetail(element);

          if (res.status === 200) {
            console.log(`Updated successfully:`, element);
            await wait(500);
          } else {
            console.warn(`Failed to update:`, element);
          }
        } catch (err) {
          console.error('UpdateShipmentDetail Error:', err);
        }
      }

      // reset loader states once all are done
      setPickupContactLoaderId(null);
      setDisabledPickupId(null);
      setDeliveryContactLoaderId(null);
      setDisabledDeliveryId(null);
      // successToast(`${type} contact details updated!`);
    };

    updateSequentially();
  };

  const handleCarrierStatus = (index, event, items) => {
    // console.log(index, items, carriers, 'carrier status:');
    // handleCheckActiveCarriers(index, event, items);

    setCarriers(prevArray => {
      const newArray = [...prevArray];
      newArray[index].active = event.target.checked;
      return newArray;
    });
    // localStorage.setItem('currentCarriers', JSON.stringify(carriers));
    setTimeout(() => {
      checkAllSelected();
    }, 10);
  };

  const handleAllActiveCarriers = event => {
    setAllCarriersChecked(event.target.checked);
    for (let i = 0; i < carriers.length; i++) {
      // handleCheckActiveCarriers(i, event, carriers[i]);
      setCarriers(prevArray => {
        const newArray = [...prevArray];
        newArray[i].active = event.target.checked;
        return newArray;
      });
      setTimeout(() => {
        checkAllSelected();
      }, 10);

      // handleCarrierStatus(i, event, carriers[i]);
    }
    // setTimeout(() => {
    //   localStorage.setItem('currentCarriers', JSON.stringify(carriers));
    // }, 10);
  };
  const handleCreateCarrier = () => {
    history.push({
      pathname: '/create-carrier',
      state: {
        quickQuoteData: previousQuoteId
      }
    });
  };
  let obj = {};
  let deepClone = JSON.parse(JSON.stringify(obj));

  const memoizedCarriers = useMemo(
    () => carriersFinalArray,
    [carriersFinalArray]
  );

  const memoizedDataToShow = useMemo(() => {
    try {
      return JSON.parse(props?.location?.state?.pickupRowData || '{}');
    } catch (error) {
      console.error('Error parsing pickupRowData:', error);
      return {};
    }
  }, [props?.location?.state?.pickupRowData]);

  const memoizedState = useMemo(() => obj, [JSON.stringify(obj)]); // eslint-disable-line react-hooks/exhaustive-deps

  const memoizedPreviousProps = useMemo(
    () => PreviousProps,
    [JSON.stringify(PreviousProps)] // eslint-disable-line react-hooks/exhaustive-deps
  );

  const memoizedPreviousRowDetails = useMemo(
    () => previousQuoteId,
    [previousQuoteId]
  );

  // You can also wrap the entire child component in useMemo if needed
  const ratingScreen = useMemo(
    () => (
      <TLRatingScreen
        shipStatus={shipStatus}
        setShipStatus={setShipStatus}
        quoteNumber={quoteNumber}
        state={memoizedState}
        quoteMode={quoteMode}
        equipmentType={equipmentType}
        reeferTemp={reeferTemp}
        reeferTempUnit={reeferTempUnit}
        rateType={'Quick'}
        shipmentId={createdShipmentId}
        previousRowDetails={memoizedPreviousRowDetails}
        handleViewTLRates={handleSynchRatesRequest}
        TLQuoteId={TLQuoteId}
        PreviousProps={memoizedPreviousProps}
        carriers={memoizedCarriers}
        deepClone={deepClone}
        totalLBSWeight={300}
        quote='quote'
        DataToShow={memoizedDataToShow}
        ReloadQuote={reloadQuote}
        handleListItemClick={handleListItemClick}
        selectedIndex={selectedIndex}
        previousTab={'TLcarrier'}
        handleNegotiateRate={handleNegotiateRate}
        isLoading={isLoading}
        ApiFailed={ApiFailed}
        ApiErrorMessage={ApiErrorMessage}
      />
    ),
    [
      shipStatus,
      quoteNumber,
      quoteMode,
      createdShipmentId,
      memoizedPreviousRowDetails,
      TLQuoteId,
      memoizedPreviousProps,
      memoizedCarriers,
      memoizedState,
      deepClone,
      memoizedDataToShow,
      reloadQuote,
      selectedIndex,
      isLoading,
      ApiFailed,
      ApiErrorMessage,
      // Functions that don't change (or use useCallback in parent)
      setShipStatus,
      handleSynchRatesRequest,
      handleListItemClick,
      handleNegotiateRate
    ]
  );

  const handleStepperContent = (index, label) => {
    if (index === 0) {
      if (props?.location?.state?.disptachOpen === 'Get Quote') {
        return (
          <Box
            className='ParentFlexDiv'
            sx={
              browser === 'Firefox'
                ? { marginTop: 1, marginLeft: '10%' }
                : { marginTop: 0, marginLeft: '10%' }
            }
          >
            <br />
            <div className='LocationsClass'>
              <div>
                <TextField
                  sx={{ width: '63vw' }}
                  disabled
                  label='Ship From'
                  variant='standard'
                  value={
                    props?.location?.state?.rateType !== 'Quick Quote'
                      ? PreviousProps?.shipFrom?.streetLines
                      : PreviousProps?.paymentTerms === 'Outbound Prepaid'
                        ? PreviousProps?.locationName
                        : PreviousProps?.originCity +
                          ' ' +
                          PreviousProps?.originState +
                          ' ' +
                          PreviousProps?.originZip +
                          ' ' +
                          PreviousProps?.originCountry
                  }
                />
              </div>
            </div>

            <div className='LocationsClass'>
              <TextField
                InputProps={{
                  disableUnderline: true
                }}
                disabled
                variant='standard'
                // error={Boolean(validationErrors['originDate'])}
                // helperText={validationErrors['originDate']}
                onChange={e => setOriginDate(new Date(e.target.value))}
                size='small'
                // defaultValue={materialDateInput}
                value={PreviousProps?.pickupDate}
                sx={{ width: '43vw', mt: 2 }}
                // type='date'
                label={isQuickQuoteRate && 'Date'}
              />
              <div>
                <div
                  className='mt-3 d-flex flex-column'
                  style={{ width: '20vw' }}
                >
                  <div
                    style={{
                      fontSize: 13,
                      color: 'rgba(0, 0, 0, 0.58)'
                    }}
                  >
                    Pickup Hours
                  </div>
                  <div className='mt-2 d-flex justify-content-between'>
                    <TextField
                      label='Open Time'
                      value={originOpenTimeValue}
                      onChange={e => {
                        setOriginOpenTimeValue(e.target.value);
                        setValidationErrors({
                          ...validationErrors,
                          originOpenTime: null
                        });
                      }}
                      type='time'
                      sx={{ width: '48%' }}
                    />

                    <TextField
                      label='Close Time'
                      value={originCloseTimeValue}
                      onChange={e => {
                        setOriginCloseTimeValue(e.target.value);
                        setValidationErrors({
                          ...validationErrors,
                          originOpenTime: null
                        });
                      }}
                      type='time'
                      sx={{ width: '48%' }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              style={
                browser === 'Firefox'
                  ? { marginBottom: 30 }
                  : { marginBottom: 3, marginTop: '-20px' }
              }
            >
              <h6>Pickup Instructions</h6>
              <ReactQuill
                style={
                  browser === 'Firefox'
                    ? {
                        width: '63vw',
                        height: '5vh',
                        marginBottom: 20,
                        marginTop: 0
                      }
                    : {
                        width: '63vw',
                        marginTop: 0
                      }
                }
                value={pickupRemarks}
                onChange={e => {
                  setPickupRemarks(e);
                  setValidationErrors({
                    ...validationErrors,
                    pickupRemarks: null
                  });
                }}
              />
              {/* <div>
              <h2>Preview:</h2>
              <div dangerouslySetInnerHTML={{ __html: pickupInstContent }} />
            </div> */}
            </div>

            <div className='LocationsClass'>
              <div>
                <TextField
                  sx={{ width: '63vw', mt: 1 }}
                  disabled
                  label='Ship To'
                  variant='standard'
                  value={
                    props?.location?.state?.rateType !== 'Quick Quote'
                      ? PreviousProps?.shipTo?.streetLines
                      : PreviousProps?.paymentTerms === 'Inbound Collect'
                        ? PreviousProps?.locationName
                        : PreviousProps?.destinationCity +
                          ' ' +
                          PreviousProps?.destinationState +
                          ' ' +
                          PreviousProps?.destinationZip +
                          ' ' +
                          PreviousProps?.destinationCountry
                  }
                />
              </div>
            </div>
            <div className='LocationsClass'>
              <TextField
                disabled
                InputProps={{
                  disableUnderline: true
                }}
                variant='standard'
                // error={Boolean(validationErrors['originDate'])}
                // helperText={validationErrors['originDate']}
                // onChange={e => setOriginDate(new Date(e.target.value))}
                size='small'
                // defaultValue={materialDateInput}
                value={PreviousProps?.deliveryDate}
                sx={{ width: '43vw', mt: 2 }}
                // type='date'
                label={
                  props?.location?.state?.rateType !== 'Quick Quote' &&
                  'Est Delivery Date'
                }
              />
              <div>
                <div
                  className='mt-3 d-flex flex-column'
                  style={{ width: '20vw' }}
                >
                  <div
                    style={{
                      fontSize: 13,
                      color: 'rgba(0, 0, 0, 0.58)'
                    }}
                  >
                    Delivery Hours
                  </div>

                  <div className='mt-2 d-flex justify-content-between'>
                    <TextField
                      label='Open Time'
                      value={destinationOpenTimeValue}
                      onChange={e => {
                        setDestinationOpenTimeValue(e.target.value);
                        setValidationErrors({
                          ...validationErrors,
                          originOpenTime: null
                        });
                      }}
                      type='time'
                      sx={{ width: '48%' }}
                    />

                    <TextField
                      label='Close Time'
                      value={destinationCloseTimeValue}
                      onChange={e => {
                        setDestinationCloseTimeValue(e.target.value);
                        setValidationErrors({
                          ...validationErrors,
                          originOpenTime: null
                        });
                      }}
                      type='time'
                      sx={{ width: '48%' }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <Grid
              container
              sx={{
                mt: {
                  xs: 1,
                  sm: 1,
                  md: 1,
                  lg: -1,
                  xl: -1
                },
                mb: 6
              }}
            >
              <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
                <h6>Delivery Instructions</h6>
                <ReactQuill
                  style={{
                    height: '8vh',
                    paddingBottom: 0
                  }}
                  value={deliveryRemarks}
                  onChange={e => {
                    setDeliveryRemarks(e);
                    setValidationErrors({
                      ...validationErrors,
                      deliveryRemarks: null
                    });
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        );
      } else
        return (
          <Box className='ParentFlexDiv' sx={{ mt: 5 }}>
            <div
              className='LocationsClass'
              style={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <Autocomplete
                forcePopupIcon={
                  PreviousProps?.shipmentStatus === 'Booked' ? false : true
                }
                fullWidth
                sx={{ mt: 2 }}
                disabled={
                  PreviousProps?.shipmentStatus === 'Booked' ? true : false
                }
                size='small'
                renderOption={(PreviousProps, option) => (
                  <Box style={{ fontSize: 13 }} {...PreviousProps}>
                    <li {...PreviousProps}>
                      {' '}
                      {
                        <div className='carriers_logo_Parent'>
                          {option.title === 'Others' ? (
                            <LocalShippingIcon className='others_carrier_logo' />
                          ) : (
                            <img
                              style={{ objectFit: 'fill' }}
                              className='carriers_logo'
                              alt={option?.carrierLogo}
                              src={option?.carrierLogo}
                            />
                          )}
                        </div>
                      }{' '}
                      {option.title}
                    </li>
                  </Box>
                )}
                value={
                  PreviousProps?.shipmentStatus === 'Booked'
                    ? PreviousProps?.carrierName
                    : otherCarrierName
                      ? otherCarrierName
                      : carrierName
                }
                onChange={(event, newValue) => {
                  newValue?.title === 'Others' && setOpenOtherCarrier(true);
                  setCarrierName({
                    title: newValue?.title,
                    logo: newValue?.carrierLogo?.logo
                  });
                  // setCarrierIdForApi(newValue?.carrierID);
                  newValue?.title !== 'Others' && setOtherCarrierName('');
                  setCarrierName(newValue);
                  setValidationErrors({
                    ...validationErrors,
                    carrierName: null
                  });
                }}
                options={props?.location?.state?.carrierApiNames}
                getOptionLabel={option => {
                  // Value selected with enter, right from the input
                  if (typeof option === 'string') {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return option.title;
                }}
                renderInput={params => (
                  <TextField
                    fullWidth
                    {...params}
                    // sx={{ width: '38vw' }}
                    variant='standard'
                    error={Boolean(validationErrors['carrierName'])}
                    helperText={validationErrors['carrierName']}
                    FormHelperTextProps={{ style: { margin: ' 5 30 0 0' } }}
                    label='Carrier Names'
                    InputProps={{
                      ...params.InputProps,
                      disableUnderline:
                        PreviousProps?.shipmentStatus === 'Booked'
                          ? true
                          : false,
                      startAdornment: (carrierName !== null ||
                        otherCarrierName) && (
                        <div
                          style={{ margin: '0 10 0 0' }}
                          className='carriers_logo_Parent'
                        >
                          {otherCarrierName ||
                          carrierName?.title === 'Others' ? (
                            <LocalShippingIcon className='others_carrier_logo' />
                          ) : (
                            <img
                              style={{ objectFit: 'fill' }}
                              className='carriers_logo'
                              alt={carrierName?.carrierLogo}
                              src={carrierName?.carrierLogo}
                            />
                          )}
                        </div>
                      )
                    }}
                  />
                )}
              />
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%'
                }}
              >
                <TextField
                  fullWidth
                  // className='RightMarginItems'
                  InputProps={{
                    disableUnderline: true
                  }}
                  variant='standard'
                  disabled
                  sx={{ mt: 2 }}
                  value={PreviousProps?.totalNetWeight}
                  FormHelperTextProps={{ style: { margin: ' 5 30 0 0' } }}
                  // InputLabelProps={{ style: { fontSize: 13 } }}
                  label='Total Net Weight(lbs)'
                />
              </Box>
            </div>
            {/* <div
              className='LocationsClass'
              style={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <Autocomplete
                fullWidth
                disabled
                renderOption={(PreviousProps, option) => (
                  <Box style={{ fontSize: 13 }} {...PreviousProps}>
                    {option}
                  </Box>
                )}
                className='Margintop'
                // sx={{ width: '38vw' }}
                name='Class'
                size='small'
                options={ClassArray}
                // defaultValue='50'
                value={PreviousProps?.details?.[0]?.freightClass}
                onChange={(event, newValue) =>
                  handleClassInputChange('Class', index, newValue)
                }
                // sx={{ marginLeft: 1 }}
                renderInput={params => (
                  <TextField
                    fullWidth
                    label='Freight Class'
                    variant='standard'
                    sx={{}}
                    // placeholder='Payment Type'

                    {...params}
                    InputProps={{
                      disableUnderline: true
                      // ...params.InputProps
                    }}
                  />
                )}
              />

              <TextField
                fullWidth
                className='RightMarginItems'
                InputProps={{
                  disableUnderline: true
                }}
                sx={{ m: 2 }}
                variant='standard'
                disabled={
                  PreviousProps?.carrierApiNames === 'carrierApiNames'
                    ? false
                    : true
                }
                label='NMFC'
                name='NMFCnumber'
                // defaultValue={
                //   PreviousProps?.carrierApiNames === 'carrierApiNames'
                //     ? ''
                //     : '5242141'
                // }
                value={PreviousProps?.details?.[0]?.nmfc}
                onChange={event =>
                  handleClassInputChange('NMFCnumber', index, event)
                }
                size='small'
                id='outlined-password-input'
                // type='number'
                autoComplete='current-password'
                // value={'149980-02'}
              />
            </div> */}
            <div
              // className='LocationsClass'
              style={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <TextField
                fullWidth
                // className='RightMarginItems'
                InputProps={{
                  disableUnderline: true
                }}
                variant='standard'
                disabled
                sx={{ mt: 2 }}
                value={
                  PreviousProps?.totalGrossWeight
                    ? PreviousProps?.totalGrossWeight
                    : ''
                }
                FormHelperTextProps={{ style: { margin: ' 5 30 0 0' } }}
                // InputLabelProps={{ style: { fontSize: 13 } }}
                label='Total Gross Weight (lbs)'
              />
              <TextField
                fullWidth
                // className='RightMarginItems'
                InputProps={{
                  disableUnderline: true
                }}
                sx={{ mt: 2 }}
                variant='standard'
                disabled
                label='Customer PO#'
                value={PreviousProps?.clientPONumber}
                onChange={event =>
                  handleClassInputChange('NMFCnumber', index, event)
                }
                size='small'
                id='outlined-password-input'
                // type='number'v
                autoComplete='current-password'
                // value={'149980-02'}
              />{' '}
            </div>
            <div
              className='LocationsClass'
              style={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <TextField
                fullWidth
                // className='RightMarginItems'
                InputProps={{
                  disableUnderline: true
                }}
                sx={{ mt: 2 }}
                variant='standard'
                disabled
                label='Shipment #'
                value={PreviousProps?.soNumber}
                // onChange={event =>
                //   handleClassInputChange('NMFCnumber', index, event)
                // }
                size='small'
                id='outlined-password-input'
                // type='number'v
                autoComplete='current-password'
                // value={'149980-02'}
              />{' '}
              <TextField
                InputProps={{
                  disableUnderline: true
                }}
                disabled
                fullWidth
                className='RightMarginItems'
                variant='standard'
                inputProps={{ disableUnderline: true }}
                // disabled
                value={pickupNumber}
                onChange={e => setPickupNumber(e.target.value)}
                type='text'
                size='small'
                sx={{ m: 2 }}
                label='Service Type'
              />
            </div>
            <TextField
              // disabled={
              //   props?.location?.state?.disptachOpen === 'PickUp'
              //     ? false
              //     : true
              // }
              // fullWidth
              sx={{ width: '40vw' }}
              className='RightMarginItems'
              value={refOrQuoteNmb}
              error={Boolean(validationErrors['refOrQuoteNmbErr'])}
              helperText={validationErrors['refOrQuoteNmbErr']}
              onChange={e => {
                setRefOrQuoteNmb(e.target.value);
                setValidationErrors({
                  ...validationErrors,
                  refOrQuoteNmbErr: null
                });
              }}
              size='small'
              // sx={{ mt: 2 }}
              label='Ref / Quote# If any'
              type='text'
              variant='standard'
              inputProps={{ disableUnderline: true }}
            />
          </Box>
        );
    } else if (index === 1) {
      if (props?.location?.state?.disptachOpen === 'Get Quote') {
        // let obj = {
        //   shipmentType: RatesObj?.shipmentType,
        //   location: 'location',
        //   paymentType: 'Third Party',
        //   shipFrom: {
        //     city: RatesObj?.originCity?.trim(),
        //     stateOrProvinceCode: RatesObj?.originState?.trim(),
        //     postalCode: RatesObj?.originZipCode,
        //     countryCode: 'USA',
        //     residential: true,
        //     streetLines: RatesObj?.originAddress?.trim()
        //   },
        //   shipTo: {
        //     city: RatesObj?.destinationCity.trim(),
        //     stateOrProvinceCode: RatesObj?.destinationState.trim(),
        //     postalCode: RatesObj?.destinationZipCode,
        //     countryCode: 'USA',
        //     residential: true,
        //     streetLines: RatesObj?.destinationAddress.trim()
        //   },
        //   shipmentDate: new Date(),
        //   isHazmat: hazmatSwitch,
        //   commodityInfo: [
        //     {
        //       freightClass: '50',
        //       packaging: RatesObj?.packagingType,
        //       pieces: RatesObj?.details[0]?.pieces,
        //       weight: {
        //         units: 'lbs',
        //         value: RatesObj?.details[0]?.netWeight
        //       },
        //       nmfc: RatesObj?.details[0]?.itemNumber,
        //       dimensions: {
        //         length: 0,
        //         width: 0,
        //         height: 0,
        //         dimensionsUom: 'cm',
        //         isStackable: false
        //       }
        //     }
        //   ],

        //   pickupOptions: {
        //     inside: insidePickupSwitch,
        //     liftGateServices: liftgatePickupSwitch,
        //     residential: residentialPickupSwitch,
        //     secureAccess: secureAccesPickupSwitch,
        //     limitedAccess: limitedPickupAccessSwitch,
        //     freezeProtection: freezeProtectionPickupSwitch,
        //     overLength: overlengthPickupSwitch,
        //     overLengthValue: overLengthValue ? parseFloat(overLengthValue) : 0,
        //     callBeforeDelivery: false
        //   },
        //   deliveryOptions: {
        //     inside: insideDeliverySwitch,
        //     liftGateServices: liftgateDeliverySwitch,
        //     residential: residentialDeliverySwitch,
        //     secureAccess: secureAccesDeliverySwitch,
        //     limitedAccess: limitedDeliverySwitch,
        //     freezeProtection: false,
        //     overLength: false,
        //     overLengthValue: 0,
        //     callBeforeDelivery: callBeforeDeliveryServicesSwitch
        //   },
        //   codAmount: CODAmount ? parseInt(CODAmount) : 0,
        //   declaredValue: DeclaredValue ? parseInt(DeclaredValue) : 0,
        //   agencyId: AgencyID ? AgencyID : 0
        // };
        // let deepClone = JSON.parse(JSON.stringify(obj));
        // deepClone.shipFrom.countryCode = 'USA';

        function TabPanel(props) {
          const { children, value, index, ...other } = props;

          return (
            <div
              role='tabpanel'
              hidden={value !== index}
              id={`simple-tabpanel-${index}`}
              aria-labelledby={`simple-tab-${index}`}
              {...other}
            >
              {value === index && (
                <Box sx={{ p: 3 }}>
                  <Typography>{children}</Typography>
                </Box>
              )}
            </div>
          );
        }

        TabPanel.propTypes = {
          children: PropTypes.node,
          index: PropTypes.number.isRequired,
          value: PropTypes.number.isRequired
        };

        const handleClose = () => {
          setTabChangeDialog(false);
          setTabChangeConfrim(false);
        };

        function CarriersTabPanel(props) {
          const { children, value, index, ...other } = props;

          return (
            <div
              role='tabpanel'
              hidden={value !== index}
              id={`full-width-tabpanel-${index}`}
              aria-labelledby={`full-width-tab-${index}`}
              {...other}
            >
              {value === index && (
                <Box sx={{ p: 3 }}>
                  <Typography>{children}</Typography>
                </Box>
              )}
            </div>
          );
        }

        CarriersTabPanel.propTypes = {
          children: PropTypes.node,
          index: PropTypes.number.isRequired,
          value: PropTypes.number.isRequired
        };

        function Carriersa11yProps(index) {
          return {
            id: `full-width-tab-${index}`,
            'aria-controls': `full-width-tabpanel-${index}`
          };
        }

        const TabLabel = ({ icon, text }) => (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {icon}
            <Typography fontWeight={500} sx={{ textTransform: 'capitalize' }}>
              {text}
            </Typography>
          </Box>
        );
        const CarriersGreenSwitch = ({ checked, onChange, ...props }) => {
          return (
            <Switch
              checked={checked}
              onChange={onChange}
              sx={{
                width: 40,
                height: 22,
                padding: 0,
                '& .MuiSwitch-switchBase': {
                  padding: 0.2,
                  margin: 0.2,
                  '&.Mui-checked': {
                    transform: 'translateX(16px)',
                    color: '#fff',
                    marginLeft: 0.5,
                    '& .MuiSwitch-thumb': {
                      backgroundColor: '#fff'
                    },
                    '& + .MuiSwitch-track': {
                      backgroundColor: '#087f23',
                      border: '2px solid #087f23',
                      opacity: 1
                    }
                  }
                },
                '& .MuiSwitch-thumb': {
                  width: 15,
                  height: 15,
                  backgroundColor: 'gray'
                },
                '& .MuiSwitch-track': {
                  borderRadius: 13,
                  border: '2px solid #ccc',
                  backgroundColor: 'transparent',
                  opacity: 1
                }
              }}
              {...props}
            />
          );
        };
        const SelectAllGreenSwitch = ({ checked, onChange, ...props }) => {
          return (
            <Switch
              checked={checked}
              onChange={onChange}
              sx={{
                width: 41,
                height: 22,
                padding: 0,
                '& .MuiSwitch-switchBase': {
                  padding: 0.2,
                  margin: 0.2,
                  '&.Mui-checked': {
                    transform: 'translateX(16px)',
                    color: '#fff',
                    marginLeft: 0.5,
                    '& .MuiSwitch-thumb': {
                      backgroundColor: '#fff'
                    },
                    '& + .MuiSwitch-track': {
                      backgroundColor: '#087f23',
                      border: '2px solid #087f23',
                      opacity: 1
                    }
                  }
                },
                '& .MuiSwitch-thumb': {
                  width: 15,
                  height: 15,
                  backgroundColor: 'gray'
                },
                '& .MuiSwitch-track': {
                  borderRadius: 13,
                  border: '2px solid #ccc',
                  backgroundColor: 'transparent',
                  opacity: 1
                }
              }}
              {...props}
            />
          );
        };

        const ViewDetailsPopover = ({ details }) => {
          const [anchorEl, setAnchorEl] = useState(null);

          const handleClick = event => {
            setAnchorEl(event.currentTarget);
          };

          const handleClose = () => {
            setAnchorEl(null);
          };

          const open = Boolean(anchorEl);

          return (
            <div>
              <Typography
                variant='caption'
                sx={{
                  fontSize: 12,
                  color: '#1976d2',
                  textDecoration: 'none',
                  cursor: 'pointer'
                }}
                onClick={handleClick}
              >
                View Details
                {Array.isArray(details) &&
                  details?.length > 1 &&
                  (open ? (
                    <KeyboardArrowUpIcon fontSize='small' />
                  ) : (
                    <KeyboardArrowDownIcon fontSize='small' />
                  ))}
              </Typography>

              <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                PaperProps={{
                  sx: { minWidth: 250, maxHeight: 300, overflow: 'auto' }
                }}
              >
                <Box>
                  {details?.map((item, index) => (
                    <Box key={index}>
                      <MenuItem onClick={handleClose}>
                        <Typography variant='body2' sx={{ fontSize: 13 }}>
                          {item}
                        </Typography>
                      </MenuItem>
                      {index < details?.length - 1 && <Divider />}
                    </Box>
                  ))}
                </Box>
              </Popover>
            </div>
          );
        };

        const groupedCarriers = [[], [], []];
        const dummyGroupedCarriers = [
          [1, 2, 3],
          [1, 2, 3],
          [1, 1, 1]
        ];
        filteredCarriers?.forEach((item, index) => {
          groupedCarriers[index % 3].push({ ...item, originalIndex: index });
        });

        return (
          <Grid>
            <Dialog
              sx={{ minWidth: 300, textAlign: 'center' }}
              open={tabChangeDialog}
              onClose={handleClose}
              aria-labelledby='alert-dialog-title'
              aria-describedby='alert-dialog-description'
            >
              <DialogContent>
                <DialogContentText id='alert-dialog-description'>
                  Changing the tab will deselect all currently selected
                  carriers. Do you want to proceed?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button variant='outlined' onClick={handleClose}>
                  Cancel
                </Button>
                <Button
                  variant='contained'
                  onClick={() => {
                    handleConfimrTabChange(tabConfirmValue);
                    setValue(tabConfirmValue);
                    setTabChangeDialog(false);
                  }}
                  // autoFocus
                >
                  Confirm
                </Button>
              </DialogActions>
            </Dialog>
            <Grid sx={{ m: 1 }}>
              <Typography variant='h5'>Select Carriers</Typography>
              <Typography>
                Select trucking companies that offer {activeTab(value, '')}{' '}
                equipment for you shipment
              </Typography>
            </Grid>
            <AppBar
              position='static'
              sx={{
                mt: 1,
                px: 1,
                py: 0.4,
                bgcolor: '#f0f0f0',
                boxShadow: 'none',
                borderRaduis: '10px solid'
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}
              >
                <Tabs
                  value={value}
                  onChange={(e, newValue) => handleConfimrTabChange(newValue)}
                  variant='scrollable'
                  scrollButtons='auto'
                  aria-label='scrollable auto tabs example'
                  sx={{ flexGrow: 1 }}
                >
                  <Tab
                    sx={{
                      '&.Mui-selected': {
                        color: 'primary.main',
                        backgroundColor: 'rgba(25, 118, 210, 0.1)'
                      }
                    }}
                    label={
                      <TabLabel
                        icon={<LocalGasStationIcon fontSize='small' />}
                        text='bulk tanker'
                      />
                    }
                    {...Carriersa11yProps(0)}
                  />
                  <Tab
                    sx={{
                      '&.Mui-selected': {
                        color: 'primary.main',
                        backgroundColor: 'rgba(25, 118, 210, 0.1)'
                      }
                    }}
                    label={
                      <TabLabel
                        icon={<LocalShippingIcon fontSize='small' />}
                        text='dry van 53ft'
                      />
                    }
                    {...Carriersa11yProps(1)}
                  />
                  <Tab
                    sx={{
                      '&.Mui-selected': {
                        color: 'primary.main',
                        backgroundColor: 'rgba(25, 118, 210, 0.1)'
                      }
                    }}
                    label={
                      <TabLabel
                        icon={<DeviceThermostatIcon fontSize='small' />}
                        text='reefer'
                      />
                    }
                    {...Carriersa11yProps(2)}
                  />
                  <Tab
                    sx={{
                      '&.Mui-selected': {
                        color: 'primary.main',
                        backgroundColor: 'rgba(25, 118, 210, 0.1)'
                      }
                    }}
                    label={
                      <TabLabel
                        icon={<Inventory2Icon fontSize='small' />}
                        text='box truck'
                      />
                    }
                    {...Carriersa11yProps(3)}
                  />
                  <Tab
                    sx={{
                      '&.Mui-selected': {
                        color: 'primary.main',
                        backgroundColor: 'rgba(25, 118, 210, 0.1)'
                      }
                    }}
                    label={
                      <TabLabel
                        icon={<AirportShuttleIcon fontSize='small' />}
                        text='sprinter'
                      />
                    }
                    {...Carriersa11yProps(4)}
                  />
                  <Tab
                    sx={{
                      '&.Mui-selected': {
                        color: 'primary.main',
                        backgroundColor: 'rgba(25, 118, 210, 0.1)'
                      }
                    }}
                    label={
                      <TabLabel
                        icon={<TrainIcon fontSize='small' />}
                        text='intermodal'
                      />
                    }
                    {...Carriersa11yProps(5)}
                  />
                </Tabs>

                {value === 2 && (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      ml: 2,
                      gap: 1
                    }}
                  >
                    <TextField
                      size='small'
                      label='Reefer Temp'
                      variant='outlined'
                      value={reeferTemp == 0 ? '' : reeferTemp}
                      onChange={e => setReeferTemp(e.target.value)}
                      type='number'
                      sx={{
                        backgroundColor: 'white',
                        borderRadius: 1,
                        width: 100
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position='start'>
                            <DeviceThermostatIcon
                              fontSize='small'
                              sx={{ color: '#1565C0' }}
                            />
                          </InputAdornment>
                        )
                      }}
                    />
                    <TextField
                      select
                      size='small'
                      value={reeferTempUnit}
                      onChange={e => setReeferTempUnit(e.target.value)}
                      sx={{
                        backgroundColor: 'white',
                        borderRadius: 1,
                        width: 75
                      }}
                    >
                      <MenuItem value='°F'>°F</MenuItem>
                      <MenuItem value='°C'>°C</MenuItem>
                    </TextField>
                  </Box>
                )}

                <TextField
                  size='small'
                  placeholder='Search companies...'
                  variant='outlined'
                  onChange={e => setSearchCarrier(e.target.value)}
                  sx={{
                    ml: 2,
                    backgroundColor: 'white',
                    borderRadius: 1,
                    width: 300
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='end'>
                        <SearchIcon fontSize='small' sx={{ color: 'gray' }} />
                      </InputAdornment>
                    )
                  }}
                />
              </Box>
            </AppBar>
            <Grid
              sx={{
                mt: 1,
                display: 'flex',
                justifyContent: 'space-between'
              }}
            >
              <Grid
                gap={1}
                sx={{
                  mt: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}
              >
                <SelectAllGreenSwitch
                  checked={allCarriersChecked}
                  onChange={event => handleAllActiveCarriers(event)}
                />
                <Typography variant='body2'>Select All Carriers</Typography>
              </Grid>
              <Grid>
                <Typography>
                  Showing <b>{filteredCarriers.length}</b> companies with{' '}
                  <b>{activeTab(value, '')}</b> equipment
                </Typography>
              </Grid>
            </Grid>
            <Box
              sx={{
                height: '50vh',
                overflowX: 'hidden',
                p: 1,
                overflowY: 'auto'
              }}
            >
              <div>
                {carriersLoader ? (
                  <Grid
                    container
                    spacing={isMobile ? 1 : 5}
                    sx={{ justifyContent: 'flex-start' }}
                  >
                    {dummyGroupedCarriers.map((group, colIndex) => (
                      <Grid
                        key={colIndex}
                        item
                        xs={12}
                        sm={12}
                        md={4}
                        lg={4}
                        xl={4}
                      >
                        {group.map((_, i) => (
                          <Box
                            key={i}
                            sx={{
                              display: 'flex',
                              justifyContent: 'center',
                              mt: 4
                            }}
                          >
                            <Skeleton
                              width={'100%'}
                              height={90}
                              variant='rounded'
                            />
                          </Box>
                        ))}
                      </Grid>
                    ))}
                  </Grid>
                ) : filteredCarriers.length === 0 ? (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      flexDirection: 'column',
                      alignItems: 'center',
                      marginTop: '25vh'
                    }}
                  >
                    {' '}
                    <Typography>No carrier found for this type!</Typography>
                    {(userPermissionsArr.filter(
                      permissions => permissions.level3
                    ).length ||
                      UserIsAdmin) && (
                      <Button
                        onClick={handleCreateCarrier}
                        size='small'
                        variant='outlined'
                      >
                        Create Carrier
                      </Button>
                    )}
                  </div>
                ) : (
                  <Grid
                    container
                    spacing={isMobile ? 1 : 5}
                    sx={{ justifyContent: 'flex-start' }}
                  >
                    {groupedCarriers.map((group, colIndex) => (
                      <Grid
                        key={colIndex}
                        item
                        xs={12}
                        sm={12}
                        md={4}
                        lg={4}
                        xl={4}
                      >
                        {group.map(items => (
                          <Box
                            key={items.originalIndex}
                            sx={{
                              display: 'flex',
                              justifyContent: 'center',
                              mt: 4
                            }}
                          >
                            <Card
                              sx={{
                                width: '100%',
                                height: '130px',
                                backgroundColor: '#f5f5f5',
                                color: '#333',
                                border: '1px solid #ddd',
                                borderRadius: '10px',
                                p: 2,
                                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                                cursor: 'default',
                                '&:hover': {
                                  boxShadow: '0 3px 10px rgba(0,0,0,0.15)'
                                }
                              }}
                            >
                              <Grid
                                container
                                spacing={0}
                                // sx={{ m: 0, p: 0 }}
                              >
                                <Grid item>
                                  <Avatar
                                    variant='rounded'
                                    src={
                                      items.logo
                                        ? base_logo_url + items.logo
                                        : NoLogo
                                    }
                                    alt={items.name}
                                    sx={{
                                      height: isMobile ? 40 : 70,
                                      width: isMobile ? 60 : 70,
                                      bgcolor: '#f0f0f0',
                                      objectFit: 'fill'
                                    }}
                                  />
                                </Grid>

                                <Grid item xs sx={{ ml: 1 }}>
                                  <Typography
                                    variant='body1'
                                    fontSize={isMobile ? 14 : 19}
                                    fontWeight={600}
                                  >
                                    {items.name?.length > 26
                                      ? `${items.name.substring(0, 12)} ...`
                                      : items.name}
                                  </Typography>

                                  {items.contactEmail && (
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        m: -0.7
                                      }}
                                    >
                                      <IconButton
                                        size='small'
                                        component='a'
                                        href={`mailto:${
                                          items.contactEmail.includes(',')
                                            ? items.contactEmail.split(',')[0]
                                            : items.contactEmail
                                        }`}
                                        sx={{
                                          color: '#1976d2'
                                          // p: 0.5,
                                          // mr: 0.5
                                        }}
                                      >
                                        <EmailIcon fontSize='small' />
                                      </IconButton>
                                      <Typography
                                        fontSize={isMobile ? 11 : 13}
                                        component='a'
                                        href={`mailto:${
                                          items.contactEmail.includes(',')
                                            ? items.contactEmail.split(',')[0]
                                            : items.contactEmail
                                        }`}
                                        sx={{
                                          color: '#1976d2',
                                          textDecoration: 'none',
                                          cursor: 'pointer'
                                        }}
                                      >
                                        {items.contactEmail.includes(',')
                                          ? items.contactEmail.split(',')[0]
                                          : items.contactEmail}
                                      </Typography>
                                    </Box>
                                  )}

                                  {items.contactPhone && (
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        m: -0.9
                                      }}
                                    >
                                      <IconButton
                                        size='small'
                                        component='a'
                                        href={`tel:${items.contactPhone}`}
                                        sx={{
                                          color: 'text.primary'
                                          // p: 0.5,
                                          // mr: 0.5
                                        }}
                                      >
                                        <PhoneIcon fontSize='small' />
                                      </IconButton>
                                      <Typography
                                        fontSize={isMobile ? 11 : 14}
                                        component='a'
                                        href={`tel:${items.contactPhone}`}
                                        sx={{
                                          color: 'text.primary',
                                          textDecoration: 'underline',
                                          cursor: 'pointer'
                                        }}
                                      >
                                        {items.contactPhone}
                                      </Typography>
                                    </Box>
                                  )}
                                </Grid>
                              </Grid>

                              <Grid
                                container
                                justifyContent='space-between'
                                alignItems='center'
                                mt={0.5}
                              >
                                <Box
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    mt: 1
                                  }}
                                >
                                  {/* <VisibilityIcon
                                          fontSize='small'
                                          sx={{
                                            color: 'primary.main',
                                            mr: 0.5
                                          }}
                                        /> */}
                                  <ViewDetailsPopover
                                    details={items.contactEmail
                                      ?.split(',')
                                      .map((email, i) => (
                                        <div key={i}>{email}</div>
                                      ))}
                                  />
                                </Box>

                                <Box>
                                  <CarriersGreenSwitch
                                    checked={items.active}
                                    onChange={event =>
                                      handleCarrierStatus(
                                        items.originalIndex,
                                        event,
                                        items
                                      )
                                    }
                                    // sx={{ cursor: 'pointer' }}
                                  />
                                </Box>
                              </Grid>
                            </Card>
                          </Box>
                        ))}
                      </Grid>
                    ))}
                  </Grid>
                )}
              </div>
            </Box>
          </Grid>
        );
      } else
        return (
          <Box
            sx={{
              marginTop: 0,
              height: '60vh',
              overflowY: 'scroll',
              overflowX: 'hidden'
            }}
          >
            <Box sx={{ marginTop: 5 }}>
              <div className='OriginTitle'>Origin</div>
              <hr />

              <div className='LocationsClass'>
                <div>
                  <TextField
                    sx={{ width: '20vw' }}
                    disabled
                    label='Contact Name'
                    variant='standard'
                    value={PreviousProps?.originContactPerson}
                    InputProps={{
                      disableUnderline: true
                    }}
                  />
                </div>
                <div>
                  <TextField
                    InputProps={{
                      disableUnderline: true
                    }}
                    sx={{ width: '20vw' }}
                    disabled
                    label='Company'
                    variant='standard'
                    value={PreviousProps?.originCompany}
                  />
                </div>
              </div>

              <div className='LocationsClass'>
                <div>
                  <TextField
                    sx={{ width: '20vw', mt: 2 }}
                    disabled
                    label='Address'
                    variant='standard'
                    value={PreviousProps?.originAddress}
                    InputProps={{
                      disableUnderline: true
                    }}
                  />
                </div>
                <div>
                  <TextField
                    InputProps={{
                      disableUnderline: true
                    }}
                    variant='standard'
                    disabled
                    sx={{ width: '20vw', mt: 2 }}
                    label='City/State/Zip/Country'
                    value={
                      PreviousProps?.originCity +
                      ' ' +
                      PreviousProps?.originState +
                      ' ' +
                      PreviousProps?.originZipCode
                    }
                  />
                </div>
              </div>
              <div className='LocationsClass'>
                <div>
                  <TextField
                    sx={{ width: '20vw', mt: 2 }}
                    disabled
                    label='Phone Number'
                    variant='standard'
                    value={PreviousProps?.originContactPhone}
                    InputProps={{
                      disableUnderline: true
                    }}
                  />
                </div>
                <div>
                  <TextField
                    InputProps={{
                      disableUnderline: true
                    }}
                    sx={{ width: '20vw', mt: 2 }}
                    disabled
                    label='Email Address'
                    variant='standard'
                    value={PreviousProps?.originContactEmail}
                  />
                </div>
              </div>

              <div style={{ display: 'LocationsClass' }}>
                <TextField
                  InputProps={{
                    disableUnderline: true
                  }}
                  disabled
                  variant='standard'
                  error={Boolean(validationErrors['originDate'])}
                  helperText={validationErrors['originDate']}
                  onChange={e => setOriginDate(new Date(e.target.value))}
                  size='small'
                  value={PreviousProps?.actualPickupDate}
                  // defaultValue={materialDateInput}
                  sx={{ width: '19vw', mt: 2 }}
                  // type='date'
                  label='Pickup Date'
                />

                {/* <TextField
                InputProps={{
                  disableUnderline: true
                }}
                disabled
                variant='standard'
                FormHelperTextProps={{
                  style: { whiteSpace: 'nowrap' }
                }}
                error={Boolean(validationErrors['originOpenTime'])}
                helperText={validationErrors['originOpenTime']}
                id='time'
                onChange={e => {
                  handleTimeChange(e, 'OriginOpenTime');
                  setValidationErrors({
                    ...validationErrors,
                    originOpenTime: null
                  });
                }}
                value={originOpenTimeValue}
                size='small'
                sx={{ width: '10vw', m: 2 }}
                type='time'
                label='Open Time'
                InputLabelProps={{
                  shrink: true
                }}
              />
              <TextField
                InputProps={{
                  disableUnderline: true
                }}
                disabled
                variant='standard'
                FormHelperTextProps={{
                  style: { whiteSpace: 'nowrap' }
                }}
                error={Boolean(validationErrors['originCloseTime'])}
                helperText={validationErrors['originCloseTime']}
                id='time'
                value={originCloseTimeValue}
                onChange={e => {
                  handleTimeChange(e, 'OriginCloseTime');
                  setValidationErrors({
                    ...validationErrors,
                    originCloseTime: null
                  });
                }}
                size='small'
                sx={{ width: '10vw', margin: '15 0 0 0' }}
                type='time'
                label='Close Time'
                InputLabelProps={{
                  shrink: true
                }}
              /> */}
              </div>

              <Typography variant='h5' className='DestinationTitle'>
                Destination
              </Typography>
              <hr />
              <div className='LocationsClass'>
                <div>
                  <TextField
                    sx={{ width: '20vw' }}
                    disabled
                    label='Contact Name'
                    variant='standard'
                    // defaultValue='Robert Thomas'
                    value={PreviousProps?.destinationContactPerson}
                    InputProps={{
                      disableUnderline: true
                    }}
                  />
                </div>
                <div>
                  <TextField
                    InputProps={{
                      disableUnderline: true
                    }}
                    sx={{ width: '20vw' }}
                    disabled
                    label='Company'
                    variant='standard'
                    value={PreviousProps?.destinationCompany}
                  />
                </div>
              </div>

              <div className='LocationsClass'>
                <div>
                  <TextField
                    sx={{ width: '20vw', mt: 2 }}
                    disabled
                    label='Address'
                    variant='standard'
                    value={PreviousProps?.destinationAddress}
                    InputProps={{
                      disableUnderline: true
                    }}
                  />
                </div>
                <div>
                  <TextField
                    InputProps={{
                      disableUnderline: true
                    }}
                    variant='standard'
                    disabled
                    sx={{ width: '20vw', mt: 2 }}
                    label='City/State/Zip/Country'
                    value={
                      PreviousProps?.destinationCity +
                      ' ' +
                      PreviousProps?.destinationState +
                      ' ' +
                      PreviousProps?.destinationZipCode
                    }
                  />
                </div>
              </div>
              <div className='LocationsClass'>
                <div>
                  <TextField
                    sx={{ width: '20vw', mt: 2 }}
                    disabled
                    label='Phone Number'
                    variant='standard'
                    value={PreviousProps?.destinationContactPhone}
                    InputProps={{
                      disableUnderline: true
                    }}
                  />
                </div>
                <div>
                  <TextField
                    InputProps={{
                      disableUnderline: true
                    }}
                    sx={{ width: '20vw', mt: 2 }}
                    disabled
                    label='Email Address'
                    variant='standard'
                    value={PreviousProps?.destinationContactEmail}
                  />
                </div>
              </div>

              <div style={{ display: 'LocationsClass' }}>
                {/*  dispatch case */}
                <TextField
                  disabled
                  InputProps={{
                    disableUnderline: true
                  }}
                  variant='standard'
                  error={Boolean(validationErrors['originDate'])}
                  helperText={validationErrors['originDate']}
                  onChange={e => setOriginDate(new Date(e.target.value))}
                  size='small'
                  value={PreviousProps?.deliveryDate}
                  sx={{ width: '19vw', mt: 2 }}
                  // type='date'
                  label='Exp Delivery Date'
                />

                {/* <TextField
                InputProps={{
                  disableUnderline: true
                }}
                disabled
                variant='standard'
                FormHelperTextProps={{
                  style: { whiteSpace: 'nowrap' }
                }}
                error={Boolean(validationErrors['originOpenTime'])}
                helperText={validationErrors['originOpenTime']}
                id='time'
                onChange={e => {
                  handleTimeChange(e, 'OriginOpenTime');
                  setValidationErrors({
                    ...validationErrors,
                    originOpenTime: null
                  });
                }}
                value={originOpenTimeValue}
                size='small'
                sx={{ width: '10vw', m: 2 }}
                type='time'
                label='Open Time'
                InputLabelProps={{
                  shrink: true
                }}
              />
              <TextField
                InputProps={{
                  disableUnderline: true
                }}
                disabled
                variant='standard'
                FormHelperTextProps={{
                  style: { whiteSpace: 'nowrap' }
                }}
                error={Boolean(validationErrors['originCloseTime'])}
                helperText={validationErrors['originCloseTime']}
                id='time'
                value={originCloseTimeValue}
                onChange={e => {
                  handleTimeChange(e, 'OriginCloseTime');
                  setValidationErrors({
                    ...validationErrors,
                    originCloseTime: null
                  });
                }}
                size='small'
                sx={{ width: '10vw', margin: '15 0 0 0' }}
                type='time'
                label='Close Time'
                InputLabelProps={{
                  shrink: true
                }}
              /> */}
              </div>
            </Box>
            {/* Dispatch Preview  */}
            <div className='OriginTitle'>Shipment Information</div>
            <hr />
            <Box sx={{ mt: 5 }}>
              {/* <Typography sx={{ mb: 1 }} variant='body2'> */}
              <div className='LocationsClass'>
                <Autocomplete
                  disabled
                  sx={{ width: '20vw' }}
                  // disabled={
                  //   PreviousProps?.carrierApiNames === 'carrierApiNames' ? true : false
                  // }
                  size='small'
                  value={
                    carrierName
                      ? carrierName
                      : otherCarrierName
                        ? otherCarrierName
                        : PreviousProps?.carrierName
                  }
                  renderOption={(PreviousProps, option) => (
                    <Box style={{ fontSize: 13 }} {...PreviousProps}>
                      <li {...PreviousProps}>{option.title}</li>
                    </Box>
                  )}
                  onChange={(event, newValue) => {
                    if (typeof newValue === 'string') {
                      setCarrierName({
                        title: newValue.title
                      });

                      setValidationErrors({
                        ...validationErrors,
                        carrierName: null
                      });
                    } else if (newValue && newValue.inputValue) {
                      // Create a new value from the user input
                      setCarrierName({
                        title: newValue.inputValue
                      });
                      setValidationErrors({
                        ...validationErrors,
                        carrierName: null
                      });
                    } else {
                      setCarrierName(newValue);
                      setValidationErrors({
                        ...validationErrors,
                        carrierName: null
                      });
                    }
                  }}
                  options={PreviousProps?.carrierApiNames}
                  getOptionLabel={option => {
                    if (typeof option === 'string') {
                      return option;
                    }
                    if (option.inputValue) {
                      return option.inputValue;
                    }
                    return option.title;
                  }}
                  freeSolo
                  renderInput={params => (
                    <TextField
                      disabled
                      sx={{ width: '20vw' }}
                      variant='standard'
                      error={Boolean(validationErrors['carrierName'])}
                      helperText={validationErrors['carrierName']}
                      FormHelperTextProps={{ style: { margin: ' 5 30 0 0' } }}
                      {...params}
                      InputProps={{
                        disableUnderline: true,
                        ...params.InputProps
                      }}
                      label='Carrier Name'
                    />
                  )}
                />

                <TextField
                  // className='RightMarginItems'
                  InputProps={{
                    disableUnderline: true
                  }}
                  variant='standard'
                  disabled
                  sx={{ width: '20vw', mt: 0 }}
                  value={PreviousProps?.totalNetWeight}
                  error={Boolean(validationErrors['carrierName'])}
                  helperText={validationErrors['carrierName']}
                  FormHelperTextProps={{ style: { margin: ' 5 30 0 0' } }}
                  // InputLabelProps={{ style: { fontSize: 13 } }}
                  label='Total Net Weight(lbs)'
                />
              </div>
              {/* <div className='LocationsClass'>
                <Autocomplete
                  disabled
                  renderOption={(PreviousProps, option) => (
                    <Box style={{ fontSize: 13 }} {...PreviousProps}>
                      {option}
                    </Box>
                  )}
                  // className='Margintop'
                  sx={{ width: '20vw', mt: 2 }}
                  name='Class'
                  size='small'
                  options={ClassArray}
                  // defaultValue='50'
                  value={PreviousProps?.details?.[0]?.freightClass}
                  onChange={(event, newValue) =>
                    handleClassInputChange('Class', index, newValue)
                  }
                  // sx={{ marginLeft: 1 }}
                  renderInput={params => (
                    <TextField
                      label='Freight Class'
                      variant='standard'
                      sx={{ width: '20vw' }}
                      // placeholder='Payment Type'

                      {...params}
                      InputProps={{
                        disableUnderline: true
                        // ...params.InputProps
                      }}
                    />
                  )}
                />

                <TextField
                  // className='RightMarginItems'
                  InputProps={{
                    disableUnderline: true
                  }}
                  sx={{ width: '20vw', mt: 2 }}
                  variant='standard'
                  disabled
                  label='NMFC'
                  name='NMFCnumber'
                  // defaultValue='5242141'
                  value={PreviousProps?.details?.[0]?.nmfc}
                  onChange={event =>
                    handleClassInputChange('NMFCnumber', index, event)
                  }
                  size='small'
                  id='outlined-password-input'
                  // type='number'
                  autoComplete='current-password'
                  // value={'149980-02'}
                />
              </div> */}
              <div style={{ marginTop: 10 }} className='LocationsClass'>
                <TextField
                  // className='RightMarginItems'
                  InputProps={{
                    disableUnderline: true
                  }}
                  variant='standard'
                  disabled
                  sx={{ width: '20vw' }}
                  value={
                    PreviousProps?.totalGrossWeight
                      ? PreviousProps?.totalGrossWeight
                      : ''
                  }
                  error={Boolean(validationErrors['carrierName'])}
                  helperText={validationErrors['carrierName']}
                  FormHelperTextProps={{ style: { margin: ' 5 30 0 0' } }}
                  // InputLabelProps={{ style: { fontSize: 13 } }}
                  label='Total Gross Weight (lbs)'
                />

                <TextField
                  className='RightMarginItems'
                  InputProps={{
                    disableUnderline: true
                  }}
                  sx={{ width: '20vw', ml: 0 }}
                  variant='standard'
                  disabled
                  label='Customer PO#'
                  value={PreviousProps?.clientPONumber}
                  onChange={event =>
                    handleClassInputChange('NMFCnumber', index, event)
                  }
                  size='small'
                  id='outlined-password-input'
                  // type='number'
                  autoComplete='current-password'
                  // value={'149980-02'}
                />
              </div>
              <div style={{ marginTop: 10 }} className='LocationsClass'>
                {refOrQuoteNmb && (
                  <TextField
                    InputProps={{
                      disableUnderline: true
                    }}
                    disabled
                    className='RightMarginItems'
                    value={refOrQuoteNmb}
                    onChange={e => setRefOrQuoteNmb(e.target.value)}
                    size='small'
                    sx={
                      !proNumber
                        ? { width: '20vw', ml: 0 }
                        : { width: '20vw', ml: 0 }
                    }
                    label='Ref / Quote# If any'
                    type='text'
                    variant='standard'
                    inputProps={{ disableUnderline: true }}
                  />
                )}
                {pickupNumber && (
                  <TextField
                    className='RightMarginItems'
                    variant='standard'
                    InputProps={{
                      disableUnderline: true
                    }}
                    disabled
                    value={pickupNumber}
                    onChange={e => setPoRefNumber(e.target.value)}
                    type='text'
                    size='small'
                    sx={{ width: '20vw', mt: 0 }}
                    label='Service Type'
                  />
                )}
              </div>
              {/* <div className='LocationsClass'></div> */}
              <div className='LocationsClass'>
                <Autocomplete
                  freeSolo
                  disabled
                  className='Margintop'
                  sx={{ width: '20vw', margin: '15 0 0 0' }}
                  renderOption={(PreviousProps, option) => (
                    <Box style={{ fontSize: 13 }} {...PreviousProps}>
                      {option}
                    </Box>
                  )}
                  size='small'
                  options={PaymentTypeArr}
                  value={PreviousProps?.paymentTerms}
                  onChange={(event, newValue) => {
                    setPaymentType(newValue);
                    setValidationErrors({
                      ...validationErrors,
                      paymentTerms: null
                    });
                  }}
                  // sx={{ marginLeft: 1 }}
                  renderInput={params => (
                    <TextField
                      disabled
                      variant='standard'
                      FormHelperTextProps={{ style: { margin: '5 30 0 0' } }}
                      error={Boolean(validationErrors['paymentTerms'])}
                      helperText={validationErrors['paymentTerms']}
                      label='Freight Payment Type'
                      {...params}
                      InputProps={{
                        disableUnderline: true,
                        ...params.InputProps
                      }}
                    />
                  )}
                />
                <TextField
                  InputProps={{
                    disableUnderline: true
                  }}
                  disabled
                  className='Margintop'
                  value={PreviousProps?.soNumber}
                  // onChange={e => setProNumber(e.target.value)}
                  size='small'
                  sx={{ mt: 2 }}
                  variant='standard'
                  label='Shipment #'
                  type='text'
                  inputProps={{ disableUnderline: true }}
                />
              </div>
            </Box>

            {otherCarrierName && (
              <div className='OriginTitle'>Other Carrier Info</div>
            )}
            <hr />

            {otherCarrierName && (
              <Box className='RemarksParent'>
                <TextField
                  variant='standard'
                  InputProps={{ disableUnderline: true }}
                  disabled
                  error={Boolean(validationErrors['otherCarrierName'])}
                  helperText={validationErrors['otherCarrierName']}
                  value={otherCarrierName}
                  onChange={e => {
                    setOtherCarrierName(e.target.value);
                    setValidationErrors({
                      ...validationErrors,
                      otherCarrierName: null
                    });
                  }}
                  sx={{ width: '20vw' }}
                  size='small'
                  label='Carrier Name'
                />
                <TextField
                  variant='standard'
                  InputProps={{ disableUnderline: true }}
                  disabled
                  error={Boolean(validationErrors['truckNumber'])}
                  helperText={validationErrors['truckNumber']}
                  value={truckNumber}
                  onChange={e => {
                    setTruckNumber(e.target.value);
                    setValidationErrors({
                      ...validationErrors,
                      truckNumber: null
                    });
                  }}
                  sx={{ width: '20vw' }}
                  size='small'
                  label='Truck Number'
                />
                <TextField
                  variant='standard'
                  InputProps={{ disableUnderline: true }}
                  disabled
                  error={Boolean(validationErrors['driverName'])}
                  helperText={validationErrors['driverName']}
                  value={driverName}
                  onChange={e => {
                    setDriverName(e.target.value);
                    setValidationErrors({
                      ...validationErrors,
                      driverName: null
                    });
                  }}
                  sx={{ width: '20vw', mt: 0 }}
                  size='small'
                  label='Driver Name'
                />
                <TextField
                  variant='standard'
                  InputProps={{ disableUnderline: true }}
                  disabled
                  error={Boolean(validationErrors['driverNumber'])}
                  helperText={validationErrors['driverNumber']}
                  value={driverNumber}
                  onChange={e => {
                    setDriverNumber(e.target.value);
                    setValidationErrors({
                      ...validationErrors,
                      driverNumber: null
                    });
                  }}
                  sx={{ width: '20vw', mt: 0 }}
                  size='small'
                  label='Driver Number'
                />
              </Box>
            )}
          </Box>
        );
    } else if (index === 2) {
      if (props?.location?.state?.disptachOpen === 'Get Quote') {
        // let obj = {
        //   shipmentType: RatesObj?.shipmentType,
        //   location: 'location',
        //   paymentType: 'Third Party',
        //   shipFrom: {
        //     city: RatesObj?.originCity.trim(),
        //     stateOrProvinceCode: RatesObj?.originState.trim(),
        //     postalCode: RatesObj?.originZipCode,
        //     countryCode: 'USA',
        //     residential: true,
        //     streetLines: RatesObj?.originAddress.trim()
        //   },
        //   shipTo: {
        //     city: RatesObj?.destinationCity.trim(),
        //     stateOrProvinceCode: RatesObj?.destinationState.trim(),
        //     postalCode: RatesObj?.destinationZipCode,
        //     countryCode: 'USA',
        //     residential: true,
        //     streetLines: RatesObj?.destinationAddress.trim()
        //   },
        //   shipmentDate: new Date(),
        //   isHazmat: hazmatSwitch,
        //   commodityInfo: [
        //     {
        //       freightClass: '50',
        //       packaging: RatesObj?.details[0].packagingType,
        //       pieces: RatesObj?.details[0]?.pieces,
        //       weight: {
        //         units: 'lbs',
        //         value: RatesObj?.details[0]?.netWeight
        //       },
        //       nmfc: RatesObj?.details[0]?.itemNumber,
        //       dimensions: {
        //         length: 0,
        //         width: 0,
        //         height: 0,
        //         dimensionsUom: 'cm',
        //         isStackable: false
        //       }
        //     }
        //   ],

        //   pickupOptions: {
        //     inside: insidePickupSwitch,
        //     liftGateServices: liftgatePickupSwitch,
        //     residential: residentialPickupSwitch,
        //     secureAccess: secureAccesPickupSwitch,
        //     limitedAccess: limitedPickupAccessSwitch,
        //     freezeProtection: freezeProtectionPickupSwitch,
        //     overLength: overlengthPickupSwitch,
        //     overLengthValue: overLengthValue ? parseFloat(overLengthValue) : 0,
        //     callBeforeDelivery: false
        //   },
        //   deliveryOptions: {
        //     inside: insideDeliverySwitch,
        //     liftGateServices: liftgateDeliverySwitch,
        //     residential: residentialDeliverySwitch,
        //     secureAccess: secureAccesDeliverySwitch,
        //     limitedAccess: limitedDeliverySwitch,
        //     freezeProtection: false,
        //     overLength: false,
        //     overLengthValue: 0,
        //     callBeforeDelivery: callBeforeDeliveryServicesSwitch
        //   },
        //   codAmount: CODAmount ? parseInt(CODAmount) : 0,
        //   declaredValue: DeclaredValue ? parseInt(DeclaredValue) : 0,
        //   agencyId: AgencyID ? AgencyID : 0
        // };

        // deepClone.shipFrom.countryCode = 'USA';
        // deepClone.shipTo.countryCode = 'USA';

        function TabPanel(props) {
          const { children, value, index, ...other } = props;

          return (
            <div
              role='tabpanel'
              hidden={value !== index}
              id={`simple-tabpanel-${index}`}
              aria-labelledby={`simple-tab-${index}`}
              {...other}
            >
              {value === index && (
                <Box sx={{ p: 3 }}>
                  <Typography>{children}</Typography>
                </Box>
              )}
            </div>
          );
        }

        TabPanel.propTypes = {
          children: PropTypes.node,
          index: PropTypes.number.isRequired,
          value: PropTypes.number.isRequired
        };

        return <div>{ratingScreen}</div>;
      } else
        return (
          <Box className='ParentFlexDiv' sx={{ mt: 5 }}>
            <div className='LocationsClass'>
              <Autocomplete
                sx={{ width: '20vw' }}
                disabled={
                  PreviousProps?.shipmentStatus === 'Booked' ? true : false
                }
                size='small'
                renderOption={(PreviousProps, option) => (
                  <Box style={{ fontSize: 13 }} {...PreviousProps}>
                    <li {...PreviousProps}>
                      {' '}
                      {
                        <div className='carriers_logo_Parent'>
                          {option.title === 'Others' ? (
                            <LocalShippingIcon className='others_carrier_logo' />
                          ) : (
                            <img
                              className='carriers_logo'
                              alt={option?.carrierLogo?.name}
                              src={option?.carrierLogo?.logo}
                            />
                          )}
                        </div>
                      }{' '}
                      {option.title}
                    </li>
                  </Box>
                )}
                value={
                  PreviousProps?.shipmentStatus === 'Booked'
                    ? PreviousProps?.carrierName
                    : otherCarrierName
                      ? otherCarrierName
                      : carrierName
                }
                onChange={(event, newValue) => {
                  newValue?.title === 'Others' && setOpenOtherCarrier(true);
                  setCarrierName({
                    title: newValue?.title,
                    logo: newValue?.carrierLogo?.logo
                  });
                  newValue?.title !== 'Others' && setOtherCarrierName('');
                  setCarrierName(newValue);
                  setValidationErrors({
                    ...validationErrors,
                    carrierName: null
                  });
                }}
                options={props?.location?.state?.carrierApiNames}
                getOptionLabel={option => {
                  // Value selected with enter, right from the input
                  if (typeof option === 'string') {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return option.title;
                }}
                renderInput={params => (
                  <TextField
                    {...params}
                    sx={{ width: '20vw' }}
                    variant='standard'
                    error={Boolean(validationErrors['carrierName'])}
                    helperText={validationErrors['carrierName']}
                    FormHelperTextProps={{ style: { margin: ' 5 30 0 0' } }}
                    label='Carrier Name'
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (carrierName !== null ||
                        otherCarrierName) && (
                        <div
                          style={{ margin: '0 10 0 0' }}
                          className='carriers_logo_Parent'
                        >
                          {otherCarrierName ||
                          carrierName?.title === 'Others' ? (
                            <LocalShippingIcon className='others_carrier_logo' />
                          ) : (
                            <img
                              className='carriers_logo'
                              alt={carrierName?.carrierLogo?.name}
                              src={carrierName?.carrierLogo?.logo}
                            />
                          )}
                        </div>
                      )
                    }}
                  />
                )}
              />
              <TextField
                // className='RightMarginItems'
                InputProps={{
                  disableUnderline: true
                }}
                variant='standard'
                disabled
                sx={{ width: '20vw', ml: 2 }}
                value={PreviousProps?.totalNetWeight}
                FormHelperTextProps={{ style: { margin: ' 5 30 0 0' } }}
                // InputLabelProps={{ style: { fontSize: 13 } }}
                label='Total Net Weight(lbs)'
              />
            </div>
            {/* <div className='LocationsClass'>
              <Autocomplete
                disabled
                renderOption={(PreviousProps, option) => (
                  <Box style={{ fontSize: 13 }} {...PreviousProps}>
                    {option}
                  </Box>
                )}
                className='Margintop'
                sx={{ width: '20vw' }}
                name='Class'
                size='small'
                options={ClassArray}
                // defaultValue='50'
                value={PreviousProps?.details?.[0]?.freightClass}
                onChange={(event, newValue) =>
                  handleClassInputChange('Class', index, newValue)
                }
                // sx={{ marginLeft: 1 }}
                renderInput={params => (
                  <TextField
                    label='Freight Class'
                    variant='standard'
                    sx={{ width: '20vw' }}
                    // placeholder='Payment Type'

                    {...params}
                    InputProps={{
                      disableUnderline: true
                      // ...params.InputProps
                    }}
                  />
                )}
              />

              <TextField
                className='RightMarginItems'
                InputProps={{
                  disableUnderline: true
                }}
                sx={{ width: '20vw', m: 2 }}
                variant='standard'
                disabled={
                  PreviousProps?.carrierApiNames === 'carrierApiNames'
                    ? false
                    : true
                }
                label='NMFC'
                name='NMFCnumber'
                // defaultValue={
                //   PreviousProps?.carrierApiNames === 'carrierApiNames'
                //     ? ''
                //     : '5242141'
                // }
                value={PreviousProps?.details?.[0]?.nmfc}
                onChange={event =>
                  handleClassInputChange('NMFCnumber', index, event)
                }
                size='small'
                id='outlined-password-input'
                // type='number'
                autoComplete='current-password'
                // value={'149980-02'}
              />
            </div> */}
            <div className='LocationsClass'>
              <TextField
                disabled
                label='Shipment #'
                variant='standard'
                sx={{ width: '20vw', mt: 2 }}
                value={PreviousProps?.soNumber}
                // placeholder='Payment Type'

                InputProps={{
                  disableUnderline: true
                  // ...params.InputProps
                }}
              />
              <TextField
                className='RightMarginItems'
                InputProps={{
                  disableUnderline: true
                }}
                sx={{ width: '20vw', m: 2 }}
                variant='standard'
                disabled
                label='Customer PO#'
                value={PreviousProps?.clientPONumber}
                onChange={event =>
                  handleClassInputChange('NMFCnumber', index, event)
                }
                size='small'
                id='outlined-password-input'
                // type='number'
                autoComplete='current-password'
                // value={'149980-02'}
              />
            </div>
            <div className='LocationsClass'>
              {/* <TextField
                error={Boolean(validationErrors['proNumber'])}
                helperText={validationErrors['proNumber']}
                className='Margintop'
                value={proNumber}
                onChange={e => setProNumber(e.target.value)}
                // onChange={e => {
                //   setProNumber(e.target.value);
                //   setValidationErrors({ ...validationErrors, proNumber: null });
                // }}
                size='small'
                sx={{ width: '20vw' }}
                variant='standard'
                label='PRO#'
                type='text'
                inputProps={{ disableUnderline: true }}
              /> */}
              <TextField
                className='RightMarginItems'
                value={refOrQuoteNmb}
                onChange={e => setRefOrQuoteNmb(e.target.value)}
                size='small'
                sx={{ width: '20vw', ml: 2 }}
                label='Ref / Quote# If any'
                type='text'
                variant='standard'
                inputProps={{ disableUnderline: true }}
              />
            </div>
            <div className='LocationsClass'>
              <TextField
                className='RightMarginItems'
                variant='standard'
                inputProps={{ disableUnderline: true }}
                disabled
                value={pickupNumber}
                onChange={e => setPickupNumber(e.target.value)}
                type='text'
                size='small'
                sx={{ width: '20vw', m: 2 }}
                label='Service Type'
              />
            </div>
          </Box>
        );
    } else if (index === 3) {
      if (props?.location?.state?.disptachOpen === 'Get Quote') {
        return (
          <Box
            sx={{
              marginTop: 0,
              height: '70vh',
              overflowY: 'scroll',
              overflowX: 'hidden'
            }}
          >
            <Grid
              container
              sx={{
                p: 2,
                mt: 3,
                backgroundColor: '#EEF4FC',
                borderRadius: 2,
                width: '98%'
              }}
            >
              <Grid
                sx={{
                  width: '98%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <Grid>
                  <div className='label'>Carrier Name</div>
                  <div className='lable-text'>{carrierName}</div>
                </Grid>
                <Grid>
                  <div className='label'>Pikcup/Drop Mode</div>
                  <div className='lable-text'>{quoteMode}</div>
                </Grid>
                <Grid>
                  <div className='label'>Equipment Type</div>
                  <div className='lable-text'>{equipmentType}</div>
                </Grid>
                <Grid>
                  <div className='label'> Driver Type</div>
                  <div className='lable-text'>{driverType}</div>
                </Grid>
                <Grid>
                  <div className='label'> Quote Reference</div>
                  <div className='lable-text'>{quoteNumber}</div>
                </Grid>
                <Grid>
                  <div className='label'> Total Net Weight(lbs)</div>
                  <div className='lable-text'>
                    {formatNumberWithCommas(PreviousProps?.totalNetWeight)}
                  </div>
                </Grid>
                <Grid>
                  <div className='label'> Total Gross Weight (lbs)</div>
                  <div className='lable-text'>
                    {formatNumberWithCommas(PreviousProps?.totalGrossWeight)}
                  </div>
                </Grid>
              </Grid>
              <Grid container sx={{ display: 'flex', mt: 2 }}>
                <Grid item md={1.5} lg={1.5} xl={1.5}>
                  <div className='label'>Actual Pickup Date</div>

                  <div className='lable-text'>{selectedPickupdate}</div>
                </Grid>
                <Grid item md={1.5} lg={1.5} xl={1.5}>
                  <div className='label'>Actual Delivery Date</div>

                  <div className='lable-text'>{selectedDeliveryDate}</div>
                </Grid>
              </Grid>
            </Grid>
            <TLShipmentPreview
              // 📦 Data Props
              shipmentsDetails={shipmentsDetails}
              groupedPickupDetails={groupedPickupDetails}
              groupedDeliveryDetails={groupedDeliveryDetails}
              previousRowDetails={memoizedPreviousRowDetails}
              quoteMode={quoteMode}
              // 👥 Contact Details & State
              pickupDetailsArr={pickupDetailsArr}
              deliveryDetailsArr={deliveryDetailsArr}
              setPickupDetailsArr={setPickupDetailsArr}
              setDeliveryDetailsArr={setDeliveryDetailsArr}
              // 🔐 Validation & Refs
              PreviousProps={PreviousProps}
              companyRefs={companyRefs}
              phoneRefs={phoneRefs}
              deliveryCompanyRefs={deliveryCompanyRefs}
              deliveryPhoneRefs={deliveryPhoneRefs}
              currentValidationIndex={currentValidationIndex}
              pickupValidationErrors={pickupValidationErrors}
              deliveryCurrentValidationIndex={deliveryCurrentValidationIndex}
              deliveryValidationErrors={deliveryValidationErrors}
              // ⚙️ Utilities
              formatPhoneNumber={formatPhoneNumber}
              emailRegex={emailRegex}
              setPickupValidationErrors={setPickupValidationErrors}
              setDeliveryValidationErrors={setDeliveryValidationErrors}
            />
            <Grid
              container
              sx={{
                display: 'flex',
                p: 2,
                mt: 3,
                justifyContent: 'space-between',
                alignItems: 'center',
                backgroundColor: '#EEF4FC',
                borderRadius: 2,
                width: '98%'
              }}
            >
              <div style={{}} className='LocationsClass'>
                <TextField
                  // error={Boolean(validationErrors['saleOrderNumberError'])}
                  // helperText={validationErrors['saleOrderNumberError']}
                  sx={{ width: '20vw', backgroundColor: 'white' }}
                  variant='outlined'
                  label='Shipment #'
                  inputRef={enterSONumber}
                  value={saleOrderNumber}
                  onChange={e => {
                    setValidationErrors({
                      ...validationErrors,
                      saleOrderNumberError: null
                    });
                    setSaleOrderNumber(e.target.value);
                  }}
                  size='small'
                />
                <TextField
                  error={Boolean(validationErrors['customerPoNmbError'])}
                  helperText={validationErrors['customerPoNmbError']}
                  sx={{ ml: 1, width: '20vw', backgroundColor: 'white' }}
                  variant='outlined'
                  label='Customer PO#'
                  inputRef={enterPONumber}
                  value={customerPoNmb}
                  onChange={e => {
                    setValidationErrors({
                      ...validationErrors,
                      customerPoNmbError: null
                    });
                    setCustomerPoNmb(e.target.value);
                  }}
                  size='small'
                />
              </div>
            </Grid>
            <br />
            {(pickupInstContent || dilveryInstContent) && (
              <>
                <div className='OriginTitle'>Remarks</div>
                <hr />
                <Box className='RemarksParent'>
                  {pickupInstContent && (
                    <div>
                      <Typography variant='caption' color='GrayText'>
                        Pickup Instructions:
                      </Typography>
                      <div
                        dangerouslySetInnerHTML={{ __html: pickupInstContent }}
                      />
                    </div>
                  )}
                  {dilveryInstContent && (
                    <div style={{ marginTop: 10 }}>
                      <Typography variant='caption' color='GrayText'>
                        Delivery Instructions:
                      </Typography>
                      <div
                        dangerouslySetInnerHTML={{ __html: dilveryInstContent }}
                      />
                    </div>
                  )}
                </Box>
              </>
            )}
          </Box>
        );
      }
    }
  };

  const stepperContent = useMemo(
    () => handleStepperContent(activeStep, activeTabLabel),
    [activeStep, activeTabLabel, ratingScreen] // eslint-disable-line react-hooks/exhaustive-deps
  );

  const handleDoneShipment = DoneStatus => {
    if (DoneStatus === 'booked') {
      history.push({
        pathname: '/manage-shipments',
        state: { selectedTab: 'Booked' }
      });
    }
    if (DoneStatus === 'InTransit') {
      history.push({
        pathname: '/manage-shipments',
        state: { selectedTab: 'InTransit' }
      });
    }
    if (DoneStatus === 'Delivered') {
      history.push({
        pathname: '/manage-shipments',
        state: { selectedTab: 'Delivered' }
      });
    }

    // history.push('/');
    // if (props?.location?.state?.disptachOpen !== 'Get Quote') {
    handleReset();
    setShipmentBooked(false);
    setShipmentDispatchMsg('');
    handleResetAllData();
    // }

    // if (props?.location?.state?.disptachOpen === 'Dispatch') {
    //   setOpenOtherCarrier(false);
    //   handleReset();
    //   handlePickupClose();
    //   setShipmentDispatchMsg('');
    //   handleResetAllData();
    // }
  };

  const handleCancelShipment = () => {
    // handlePickupClose();
    handleReset();
    setShipmentFailed(false);
    history.push('/');
  };

  const perviousBtnChk = () => {
    if (activeStep === 0 && quoteType !== 'Quick Quote') {
      return false;
    } else return true;
  };

  const handleBackShipment = () => {
    setShipmentFailed(false);
    setShipmentDispatchFailed(false);
    handleReset();
  };

  const stepsArray = () => {
    if (props?.location?.state?.disptachOpen === 'Get Quote') {
      const steps = [
        'Pickup Info',
        'Select Carriers',
        'Carrier Rates',
        'Preview'
      ];
      return steps;
    } else {
      const steps = ['Shipment Info', 'Preview'];
      return steps;
    }
  };
  const handleOtherCarrierClose = () => {
    setOpenOtherCarrier(false);
    setOpen(true);
    setCarrierName(null);
    // setOtherCarrierName('');
  };
  const handleSaveOtherCarrier = () => {
    const errors = {};
    if (!otherCarrierName) {
      errors['otherCarrierName'] = 'Enter carrier name';
    } else if (!truckNumber) {
      errors['truckNumber'] = 'Enter truck number';
    } else if (!driverName) {
      errors['driverName'] = 'Enter driver name';
    } else if (!driverNumber) {
      errors['driverNumber'] = 'Enter driver number';
    } else if (phoneNumberValidError) {
      errors['driverNumber'] = 'Enter Valid Phone Number (XXX) XXX-XXXX';
    }
    setValidationErrors(errors);
    if (otherCarrierName && truckNumber && driverName && driverNumber) {
      handleOtherCarrierClose();
    }
  };
  const handleNextButton = () => {
    if (stepsArray().length === 2) {
      if (
        props?.location?.state?.disptachOpen === 'Dispatch' &&
        !shipmentDispatchFailed
      ) {
        return 'Dispatch';
      } else if (
        props?.location?.state?.disptachOpen === 'PickUp' &&
        !shipmentDispatchFailed
      ) {
        return 'Confirm PickUp';
      } else {
        return 'Cancel';
      }
    }
    if (
      props?.location?.state?.disptachOpen === 'Get Quote' &&
      !shipmentFailed &&
      stepsArray().length === 4
    ) {
      return 'Confirm';
    }
    if (
      props?.location?.state?.disptachOpen === 'Get Quote' &&
      shipmentFailed &&
      stepsArray().length === 3
    ) {
      return 'Cancel';
    }
  };
  const handlePhoneNumberPaste = event => {
    // Prevent the default paste behavior
    event.preventDefault();

    // Get the pasted text from clipboard
    const pastedText = event.clipboardData.getData('text/plain');

    // Remove non-numeric characters from pasted text
    const cleanedText = pastedText.replace(/\D/g, '');

    // Apply formatting logic
    const formattedValue = cleanedText.replace(
      /^(\d{3})(\d{3})(\d{4})$/,
      '($1) $2-$3'
    );
    setDriverNumber(formattedValue);

    // Perform validation on the formatted value
    const errors = {};
    const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
    const isValidPhoneNumber = phoneRegex.test(formattedValue);

    if (isValidPhoneNumber) {
      setPhoneNumberValidError(false);
      setValidationErrors({ ...validationErrors, driverNumber: null });
    } else {
      setPhoneNumberValidError(true);
      errors['driverNumber'] = 'Enter Valid Phone Number (XXX) XXX-XXXX';
      setValidationErrors(errors);
    }
  };
  const handlePhoneNumberChange = event => {
    const inputValue = event.target.value;
    // Remove non-numeric characters and retain formatting
    const formattedValue = inputValue
      .replace(/\D/g, '')
      .replace(/^(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3');
    setDriverNumber(formattedValue);

    // Perform validation on the formatted value
    const errors = {};
    const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
    const isValidPhoneNumber = phoneRegex.test(formattedValue);

    if (isValidPhoneNumber) {
      setPhoneNumberValidError(false);
      setValidationErrors({ ...validationErrors, driverNumber: null });
    } else {
      setPhoneNumberValidError(true);
      errors['driverNumber'] = 'Enter Valid Phone Number (XXX) XXX-XXXX';
      setValidationErrors(errors);
    }
  };

  useEffect(() => {}, []);
  const ShipmentContent = () => {
    if (pickUpLoader) {
      return (
        <Box sx={{ textAlign: 'center' }}>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <CircularProgress />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </Box>
      );
    }
    if (shipmentFailed || shipmentDispatchFailed) {
      return (
        <Box sx={{ textAlign: 'center' }}>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <WarningAmberIcon style={{ fontSize: 150, color: '#D32F2F' }} />{' '}
          <br />
          <br />
          <Typography variant='h4'>Error</Typography>
          <br />
          <div>{shipmentFailedMsg}</div>
          <br />
          <br />
        </Box>
      );
    }
    if (shipmentDispatchMsg && !shipmentDispatchFailed) {
      return (
        <Box sx={{ textAlign: 'center' }}>
          <br />
          <br />
          <br />
          <br />
          <br />
          <CheckCircleIcon style={{ fontSize: 150, color: '#2E7D32' }} />{' '}
          <Typography variant='h4'>
            {shipmentDispatchMsg === 'InTransit'
              ? 'Your shipment has been picked-up and saved in-transit'
              : 'Your shipment has been picked-up and saved in delivered'}
          </Typography>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          {/* <br /> */}
          <Button
            sx={{
              width: '25%',
              height: 40
            }}
            variant='contained'
            onClick={() => handleDoneShipment(shipmentDispatchMsg)}
          >
            Done
          </Button>
        </Box>
      );
    }
    if (shipmentBooked) {
      return (
        <>
          <Box sx={{ textAlign: 'center' }}>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <CheckCircleIcon style={{ fontSize: 150, color: '#2E7D32' }} />{' '}
            <Typography variant='h4'>{pickupSuccessRemarks}</Typography>
            <br />
            <div className='ParentCopyNmb'>
              <Typography className='OuterCopyNmb'>
                Your Shipment has been{' '}
                {shipStatus === 'Booked' ? 'Re-Booked' : 'Booked'}!
              </Typography>
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <Button
              sx={{
                width: '25%',
                height: 40
              }}
              variant='contained'
              onClick={() => handleDoneShipment('booked')}
            >
              Done
            </Button>
          </Box>
        </>
      );
    } else {
      return (
        <Box sx={{ height: 'auto', width: '100%', overflow: 'hidden' }}>
          <Stepper
            // className='PickupStepperParent'
            activeStep={activeStep}
            alternativeLabel={isMobile ? true : false}
            // nonLinear
          >
            {stepsArray().map((label, index) => {
              const stepProps = {};

              return (
                <Step key={label} {...stepProps}>
                  <StepButton
                    color='inherit'
                    // onClick={handleStep(index, label)}
                  >
                    {label}
                  </StepButton>
                </Step>
              );
            })}
          </Stepper>
          {stepperContent}
        </Box>
      );
    }
  };

  return (
    <Grid sx={{ display: 'flex', justifyContent: 'center' }} container>
      <ToastContainer
        style={
          isMobile
            ? { width: '100%', display: 'flex', justifyContent: 'center' }
            : { width: 'auto' }
        }
        position='top-center'
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Grid item xs={12} sm={12} lg={11} xl={11}>
        <Box sx={{ maxHeight: '90vh' }}>
          <Paper sx={{ p: 2 }} className=''>
            <Dialog
              className='InnerDialog'
              open={openOtherCarrier}
              onClose={handleOtherCarrierClose}
            >
              <DialogContent>
                <DialogContentText>
                  <TextField
                    variant='standard'
                    error={Boolean(validationErrors['otherCarrierName'])}
                    helperText={validationErrors['otherCarrierName']}
                    value={otherCarrierName}
                    onChange={e => {
                      setOtherCarrierName(e.target.value);
                      setValidationErrors({
                        ...validationErrors,
                        otherCarrierName: null
                      });
                    }}
                    sx={{ width: '100%', mt: 5 }}
                    size='small'
                    label='Carrier Name'
                  />
                  <TextField
                    variant='standard'
                    error={Boolean(validationErrors['truckNumber'])}
                    helperText={validationErrors['truckNumber']}
                    value={truckNumber}
                    onChange={e => {
                      setTruckNumber(e.target.value);
                      setValidationErrors({
                        ...validationErrors,
                        truckNumber: null
                      });
                    }}
                    sx={{ width: '100%', mt: 5 }}
                    size='small'
                    label='Truck Number'
                  />
                  <TextField
                    variant='standard'
                    error={Boolean(validationErrors['driverName'])}
                    helperText={validationErrors['driverName']}
                    value={driverName}
                    onChange={e => {
                      setDriverName(e.target.value);
                      setValidationErrors({
                        ...validationErrors,
                        driverName: null
                      });
                    }}
                    sx={{ width: '49%', mt: 5 }}
                    size='small'
                    label='Driver Name'
                  />
                  <TextField
                    variant='standard'
                    error={Boolean(validationErrors['driverNumber'])}
                    helperText={validationErrors['driverNumber']}
                    value={driverNumber}
                    onChange={handlePhoneNumberChange}
                    onPaste={handlePhoneNumberPaste}
                    sx={{ width: '49%', margin: '40 0 0 8' }}
                    size='small'
                    label='Driver Number'
                    type='text'
                  />
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  sx={{ width: '49%' }}
                  variant='outlined'
                  onClick={handleOtherCarrierClose}
                >
                  Cancel
                </Button>
                <Button
                  sx={{ width: '49%' }}
                  variant='contained'
                  onClick={handleSaveOtherCarrier}
                >
                  Save
                </Button>
              </DialogActions>
            </Dialog>
            <div>
              {ShipmentContent()}
              {!shipmentDispatchMsg && !shipmentBooked && (
                <div
                  style={
                    isMobile ? { display: 'flex', flexDirection: 'column' } : {}
                  }
                  className={
                    props?.location?.state?.disptachOpen === 'Get Quote'
                      ? 'NextBtnRates'
                      : 'NextBtnDiv'
                  }
                >
                  {perviousBtnChk() === true && (
                    <Button
                      fullWidth={isMobile ? true : false}
                      // disabled={activeStep === 2 ? true : false}
                      sx={isMobile ? { mt: 6 } : { mr: 2, mt: 5 }}
                      onClick={
                        shipmentFailed || shipmentDispatchFailed
                          ? handleBackShipment
                          : handleBack
                      }
                      // className='BtnColor'
                      variant='outlined'
                    >
                      <ChevronLeftIcon sx={{ m: 0 }} className='PrevBtnIcon' />{' '}
                      Previous
                    </Button>
                  )}
                  <Button
                    fullWidth={isMobile ? true : false}
                    sx={
                      isMobile && activeStep === 0
                        ? { mt: 9 }
                        : isMobile && activeStep === 1
                          ? { mt: 2 }
                          : { mt: 5 }
                    }
                    disabled={
                      ((activeStep === 1 && enableNext) ||
                        (activeStep === 2 &&
                          selectedCarrierNameQuoteRates === '') ||
                        (activeStep === 2 &&
                          selectedCarrierNameQuoteRates === 0)) &&
                      props?.location?.state?.disptachOpen === 'Get Quote'
                        ? true
                        : false
                    }
                    onClick={
                      shipmentFailed || shipmentDispatchFailed
                        ? () => handleCancelShipment()
                        : () => handleNext(activeStep)
                    }
                    className='BtnColor'
                    variant='contained'
                  >
                    {' '}
                    {activeStep === stepsArray().length - 1
                      ? handleNextButton()
                      : shipmentFailed || shipmentDispatchFailed
                        ? 'Cancel'
                        : props?.location?.state?.disptachOpen ===
                              'Get Quote' && activeStep === 0
                          ? 'Next'
                          : props?.location?.state?.disptachOpen ===
                                'Get Quote' && activeStep === 2
                            ? shipStatus === 'Booked'
                              ? 'Re-Book'
                              : 'Book'
                            : 'Next'}
                    {/* {!shipmentFailed ||
                    (shipmentDispatchFailed && ( */}
                    <ChevronRightIcon className='NextBtnIcon' />
                    {/* ))} */}
                  </Button>
                </div>
              )}
            </div>
          </Paper>
        </Box>
      </Grid>
    </Grid>
  );
}
